import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';

import { Form, Icon, Message, Divider, Button } from 'semantic-ui-react'
import _find from 'lodash/find';
import _ from 'lodash';

import queries from '../../../utils/queries'

import SeguroPermite from '../../../components/funcionales/seguropermite';
import ListaServTar from '../../../components/deestado/listaservtar';

import getNumDiasMes from '../../../functions/getnumdiasmes';

const DetalleNivel = props => {
  return (
    <option>{props.elemento.descrCategOST}</option>
  )
};

const ListaCateg = ({list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel2Detalle = list.map((elemento, _id) => <DetalleNivel elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrCategOST" id="miListaCateg" value={permiteUpdate?argsDocum.descrCategOST:idLista.descrCategOST} onChange={(ev)=>handleChange(ev, argsDocum)}>
        {Nivel2Detalle}
      </select>
    </div>
  )
};

const DetalleNivelTOS = props => {
  return (
    <option>{props.elemento.tipoOSDirAnt}</option>
  )
};

const ListaTOS = ({styles, list, idLista, argsDocum, permiteClose, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivelTOS elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="tipoOSDirAnt" id="miListaTOS" value={permiteClose?argsDocum.tipoOSDirAnt:argsDocum.genOSDirAnt==="SI"?this.props.list[0].tipoOSDirAnt:"Seleccionar..."} onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option style={styles.input} value="">Seleccionar...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};

const DetalleNivelEC = props => {
  return (
      <option>{props.elemento.estadoCierre}</option>
  )
};

const ListaEC = ({styles, list, argsDocum, permiteClose, handleChange}) => {
  const Nivel1DetalleEC = list.map((elemento, i) => <DetalleNivelEC elemento={elemento} key={i} />);
    return(
        <div>
            <select style={styles.input} className="ui simple selection dropdown fluid" name="estadoCierre" id="miListaEC" value={permiteClose?argsDocum.estadoCierre?argsDocum.estadoCierre:"Seleccionar...":"Seleccionar..."} onChange={(ev)=>handleChange(ev, argsDocum)}>
              {Nivel1DetalleEC}
            </select>
        </div>
    )
};

//dropdown CONCEPTOS
const DetalleSelCpto = props => {
  return (
    <option dato1={props.elemento.porcImpto?props.elemento.porcImpto:""} dato2={props.elemento.descrClaseServ} dato3={props.elemento.codigoImpto?props.elemento.codigoImpto:""} value={props.elemento.descrImpto?props.elemento.descrImpto:""}>{props.elemento.descrOtrosPagCl}</option>
  )
};

const ListaCpto = ({styles, handleCpto, list}) => {
  let detalleCpto = list.map((elemento, _id) => <DetalleSelCpto elemento={elemento} key={elemento._id}/>);
  return(
    <div>
      <select style={styles.input}className="ui simple selection dropdown fluid" name="cpto" id="miListaCpto" onChange={(ev) => handleCpto(ev)}>
        <option value="">Seleccionar...</option>
        {detalleCpto}
      </select>
    </div>
  )
};
//Fin dropdown CONCEPTOS

const DetalleNivelV = props => {
  return (
      <option dato1={props.elemento.codigoTipoDoc} value={props.elemento.numeroDocum}>{props.elemento.descrRecurso}</option>
  )
};

const ListaV = ({styles, list, idLista, argsDocum, permiteClose, handleChange}) => {
  // console.log(permiteClose, idLista, argsDocum)  
  const Nivel1DetalleV = list.map((elemento, _id) => <DetalleNivelV elemento={elemento} key={elemento._id} />);
    return(
        <div>
            <select style={styles.input} className="ui simple selection dropdown fluid" name="venta" id="miListaV" value={permiteClose?argsDocum.numeroDocumV?argsDocum.numeroDocumV:"":idLista.numeroDocumV?idLista.numeroDocumV:""} onChange={(ev)=>handleChange(ev, argsDocum)}>
            <option style={styles.input} value="">Seleccionar...</option>
              {Nivel1DetalleV}
            </select>
        </div>
    )
};

const DetalleNivelClOS = props => {
  return (
      <option>{props.elemento.descrClasifOST}</option>
  )
};

const ListaClOS = ({styles, list, idLista, argsDocum, permiteClose, handleChange}) => {
  // console.log(permiteClose, list, idLista, argsDocum)  
  const Nivel1DetalleV = list.map((elemento, _id) => <DetalleNivelClOS elemento={elemento} key={elemento._id} />);
    return(
        <div>
            <select style={styles.input} className="ui simple selection dropdown fluid" name="clasifos" id="miListaClOS" value={permiteClose?argsDocum.descrClasifOST?argsDocum.descrClasifOST:"":idLista.descrClasifOST?idLista.descrClasifOST:""} onChange={(ev)=>handleChange(ev, argsDocum)}>
            <option style={styles.input} value="">Seleccionar...</option>
              {Nivel1DetalleV}
            </select>
        </div>
    )
};

const DetalleNivelNodo = props => {
  return (
      <option>{props.elemento.descrNodo}</option>
  )
};

const ListaNodo = ({styles, list, idLista, argsDocum, permiteClose, handleChange}) => {
  // console.log(permiteClose, list, idLista, argsDocum)  
  const Nivel1DetalleV = list.map((elemento, _id) => <DetalleNivelNodo elemento={elemento} key={elemento._id} />);
    return(
        <div>
            <select style={styles.input} className="ui simple selection dropdown fluid" name="nodos" id="miListaNodo" value={permiteClose?argsDocum.descrNodo?argsDocum.descrNodo:"":idLista.descrNodo?idLista.descrNodo:""} onChange={(ev)=>handleChange(ev, argsDocum)}>
            <option style={styles.input} value="">Seleccionar...</option>
              {Nivel1DetalleV}
            </select>
        </div>
    )
};

const DetalleNivelPaq = props => {
  return (
      <option value={props.elemento.codigoPaquete}>{props.elemento.descrPaquete}</option>
  )
};

const ListaPaq = ({styles, list, idLista, argsDocum, permiteClose, handleChange}) => {
  // console.log(permiteClose, list, idLista, argsDocum)  
  const Nivel1DetalleV = list.map((elemento, _id) => <DetalleNivelPaq elemento={elemento} key={elemento._id} />);
    return(
        <div>
            <select style={styles.input} className="ui simple selection dropdown fluid" name="paquete" id="miListaPaq" value={permiteClose?argsDocum.codigoPaquete?argsDocum.codigoPaquete:"":idLista.codigoPaquete?idLista.codigoPaquete:""} onChange={(ev)=>handleChange(ev, argsDocum)}>
            <option style={styles.input} value="">Seleccionar...</option>
              {Nivel1DetalleV}
            </select>
        </div>
    )
};

const DetalleNivelBodega = props => {
  return (
    <option dato1={props.elemento.codigoBodega} dato2={props.elemento.descrBodega} value={props.elemento._id}>{props.elemento.codigoBodega} ={">"} {props.elemento.descrBodega}</option>
  )
};

const ListaBodega = ({styles, handleLista, list}) => {
    const NivelDetalleBodega = list.map((elemento, _id) => <DetalleNivelBodega elemento={elemento} key={elemento._id} />);
    return(
        <div>
            <select style={styles.input} className="ui simple selection dropdown fluid" name="bodega" id="miLista3" onChange={handleLista}>
                <option style={styles.input} value="">Seleccionar...</option>
                {NivelDetalleBodega}
            </select>
        </div>
    )
};

const Servicios = ({elemento, handleChangeTar, imptosCF}) => {
  return(
    <tr className=''>
      <td className='collapsing'>
        <div className='ui fitted slider checkbox'>
          <input type='checkbox' name='estadoSelecc' id={elemento.codigoServicio} checked={elemento.estadoSelecc} onChange={(ev)=>handleChangeTar(ev, elemento, imptosCF)}/>
          <label />
        </div>
      </td>
      <td className=''>{elemento.descrClaseServ}</td>
      <td className=''>{elemento.nombreResumido}</td>
      <td className=''>{elemento.descripcionServicio}</td>
    </tr>
  )
};

const ListaServ = ({list, handleChangeTar, imptosCF}) => {
  const nivel1Detalle = list.map((elemento, _id) => <Servicios elemento={elemento} handleChangeTar={handleChangeTar} imptosCF={imptosCF} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

// //Lista servicios tarifa
// const ServiciosTar = ({elemento, permAct, handleChangeTar, imptosCF}) => {
//   const rango1Ini = (valor) => {
//     if(valor!==null){
//       return valor
//     }else{
//       return ''
//     }
//   }
//   return(
//     <tr className=''>
//       {permAct==='cambiar'?
//         <td className='collapsing'>
//           <div className='ui fitted slider checkbox'>
//             <input type='checkbox' name='estadoSeleccPpal' id={elemento.codigoServicio} checked={elemento.estadoSelecc} onChange={(ev)=>handleChangeTar(ev, elemento, imptosCF)}/>
//             <label />
//           </div>
//         </td>
//       :
//         <td className=''></td>
//       }
//       <td className=''>{elemento.descrClaseServ}</td>
//       <td className=''>{elemento.nombreResumido}</td>
//       <td className=''>{elemento.descripcionServicio}</td>
//       <td className='center aligned' style={styles1.styPaddMarg}>
//         <input type='number' step="1" style={styles1.styInput} autoComplete="off" name="numeroServicios" id={elemento.codigoServicio} value={rango1Ini(elemento.numeroServicios)} placeholder='# serv' onChange={permAct==='cambiar'?(ev)=>handleChangeTar(ev, elemento, imptosCF):()=>{}}/>
//       </td>
//       <td className='right aligned' style={styles1.styPaddMarg}>
//         <input type='number' step="1" style={styles1.styInput} autoComplete="off" name="valorServicios" id={elemento.codigoServicio} value={rango1Ini(elemento.valorServicios)} placeholder='Valor serv' onChange={permAct==='cambiar'?(ev)=>handleChangeTar(ev, elemento, imptosCF):()=>{}}/>
//       </td>
//     </tr>
//   )
// };

// const ListaServTar = ({list, permAct, handleChangeTar, imptosCF}) => {
//   const nivel1Detalle = list.map((elemento, _id) => <ServiciosTar elemento={elemento} permAct={permAct} handleChangeTar={handleChangeTar} imptosCF={imptosCF} key={elemento._id}/>);
//   return(
//     <tbody className=''>
//       {nivel1Detalle}
//     </tbody>
//   )
// };

//Lista servicios oferta
const ServiciosOf = ({elemento}) => {
  return(
    <tr className=''>
      <td className=''></td>
      <td className=''>{elemento.descrClaseServ}</td>
      <td className=''>{elemento.nombreResumido}</td>
      <td className=''>{elemento.descripcionServicio}</td>
      <td className='center aligned'>{elemento.porcDctoOferta}</td>
      <td className='center aligned'>{elemento.numDiasOferta}</td>
    </tr>
  )
};

const ListaServOf = ({list}) => {
  const nivel1Detalle = list.map((elemento, _id) => <ServiciosOf elemento={elemento} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

//Lista de equipos
const EquiposCli = ({list, elemento, permAct, handleChangeEqu, nameEstado}) => {
  return(
    <tr className=''>
      {permAct==='cambiar'?
        <td className='collapsing'>
          <div className='ui fitted slider checkbox'>
            <input type='checkbox' name={nameEstado} id={elemento.numeroSerie} checked={elemento.estadoSelecc} onChange={(ev)=>handleChangeEqu(ev, elemento, list)}/>
            <label />
          </div>
        </td>
      :
        <td className=''></td>
      }
      <td className=''>{elemento.numeroSerie}</td>
      <td className=''>{elemento.mac}</td>
      <td className=''>{elemento.descrClaseEqu}</td>
      <td className=''>{elemento.descrMarcaEqu}</td>
      <td className=''>{elemento.descrFabriEqu}</td>
    </tr>
  )
};

const ListaEquiCli = ({list, permAct, handleChangeEqu, nameEstado}) => {
  const nivel1Detalle = list.map((elemento, _id) => <EquiposCli list={list} elemento={elemento} permAct={permAct} handleChangeEqu={handleChangeEqu} nameEstado={nameEstado} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

//dropdown TIPO VIA 1
const DetalleLista = props => {
  let campo1 = ""
  if(props.seleccLista==="descrTipoVia1"||props.seleccLista==="descrTipoVia2"){
    campo1=props.elemento.descrTipoVia
  }
  if(props.seleccLista==="descrTipoUnd1"||props.seleccLista==="descrTipoUnd2"){
    campo1=props.elemento.descrTipoUnd
  }
  if(props.seleccLista==="descrTiUndMat"){
    campo1=props.elemento.descrTiUndMat
  }
  if(props.seleccLista==="descrUndMat"){
    campo1=props.elemento.descrUndMat
  }
  if(props.seleccLista==="descrEstrato"){
    campo1=props.elemento.descrEstrato
  }

  return (
    <option>{campo1}</option>
  )
};

const Lista = ({styles, seleccLista, list, handleLista4}) => {
  const detalleLista = list.map((elemento, _id) => <DetalleLista elemento={elemento} seleccLista={seleccLista} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name={seleccLista} id={seleccLista} onChange={(ev)=>handleLista4(ev, seleccLista)}>
        <option value="">Seleccionar...</option>
        {detalleLista}
      </select>
    </div>
  )
};
//Fin dropdown TIPO VIA 1

//dropdown TARIFAS
const DetalleSelTar = props => {
  return (
    <option dato1={props.elemento._id} value={props.elemento.codigoTarifa}>{props.elemento.codigoTarifa} ={">"} {props.elemento.descrTarifa}</option>
  )
};

const ListaTar = ({codigoTarifaAct, codigoTarifaNva, styles, handleTarNva, list, listTOS, cicloFact}) => {
  const cambTar = listTOS[0].permTarServ.substr(0, 12)
  let detalleTar
  if(cambTar!=="IGUAL TARIFA"){
    detalleTar = list.map((elemento, _id) => <DetalleSelTar elemento={elemento} key={elemento._id} listTOS={listTOS} codigoTarifaAct={codigoTarifaAct}/>);
  }else{
    const listTarTOS = list.filter(item => item.codigoTarifa===codigoTarifaAct);
    detalleTar = listTarTOS.map((elemento, _id) => <DetalleSelTar elemento={elemento} key={elemento._id} listTOS={listTOS} codigoTarifaAct={codigoTarifaAct}/>);
  }
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="tarifa" id="miListaTar" onChange={(ev) => handleTarNva(ev, list, codigoTarifaAct, codigoTarifaNva, listTOS, cicloFact)}>
        <option value="">Seleccionar...</option>
        {detalleTar}
      </select>
    </div>
  )
};
//Fin dropdown TARIFAS

//dropdown OFERTAS
const DetalleSelOf = props => {
  return (
    <option dato1={props.elemento._id} value={props.elemento.codigoOferta}>{props.elemento.codigoOferta} ={">"} {props.elemento.descrOferta}</option>
  )
};

const ListaOf = ({codigoOfertaAct, codigoOfertaNva, styles, handleOfNva, list}) => {
  let detalleOf = list.map((elemento, _id) => <DetalleSelOf elemento={elemento} key={elemento._id} codigoOfertaAct={codigoOfertaAct}/>);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="oferta" id="miListaOf" onChange={(ev) => handleOfNva(ev, list, codigoOfertaAct, codigoOfertaNva)}>
        <option value="">Seleccionar...</option>
        {detalleOf}
      </select>
    </div>
  )
};
//Fin dropdown OFERTAS

//dropdown DEPARTAMENTOS
const DetalleSelDe = props => {
  return (
    <option dato1={props.elemento.codigoDpto} dato2={props.elemento.codigoDptoDANE} value={props.elemento.codigoDpto}>{props.elemento.descrDpto}</option>
  )
};

const ListaDe = ({styles, handleLista, list, codigoCiudadUA, codigoDptoUA}) => {
  const detalleDe = list.map((elemento, _id) => <DetalleSelDe elemento={elemento} key={elemento._id} />);
  let selecc = true
  if(list.length===1){
    selecc = false
  }
  if(codigoCiudadUA==="Todas..."&&codigoDptoUA==="Todos..."){
    return(
      <div>
        {selecc  &&
          <select style={styles.input} className="ui simple selection dropdown fluid" name="dpto" id="miLista" onChange={handleLista}>
            <option value="">Seleccionar...</option>
            {detalleDe}
          </select>
        }
        {!selecc  &&
          <select style={styles.input} className="ui simple selection dropdown fluid" name="dpto" id="miLista">
            {detalleDe}
          </select>
        }
      </div>
    )
  }else{
    return(
      <div>
        {selecc  &&
          <select style={styles.input} className="ui simple selection dropdown fluid" name="dpto" id="miLista" onChange={handleLista}>
            {detalleDe}
          </select>
        }
        {!selecc  &&
          <select style={styles.input} className="ui simple selection dropdown fluid" name="dpto" id="miLista">
            {detalleDe}
          </select>
        }
      </div>
    )
  }
};
//Fin dropdown DEPARTAMENTOS
//dropdown CIUDADES => solo ciudades del departamento seleccionado
const DetDetalleSelCi = props => {
  return(
    <option dato1={props.elemento.codigoCiudad} dato2={props.elemento.codigoCiudadInterno?props.elemento.codigoCiudadInterno:""} dato3={props.elemento.codBarrasRdo?props.elemento.codBarrasRdo:""} dato4={props.elemento.codigoMunicipioDANE?props.elemento.codigoMunicipioDANE:""} dato5={props.elemento.codigoPostalDANE?props.elemento.codigoPostalDANE:""} value={props.elemento.codigoCiudad}>{props.elemento.nombreCiudad}</option>
  )
}

const DetalleSelCi = ({styles, elemento, handleLista1, codigoCiudadUA}) => {
  let selecc = true
  if(elemento.ciudades.length===1){
    selecc = false
  }

  let detDetalleCi = []
  if(codigoCiudadUA==="Todas..."){
    detDetalleCi = elemento.ciudades.map((elemento, i) => <DetDetalleSelCi styles={styles} elemento={elemento} key={i} />);
    return (
      <div>
        {selecc  &&
          <select style={styles.input} className="ui simple selection dropdown fluid" name="ciudad" id="miLista1" onChange={handleLista1}>
            <option value="">Seleccionar...</option>
            {detDetalleCi}
          </select>
        }
        {!selecc  &&
          <select style={styles.input} className="ui simple selection dropdown fluid" name="ciudad" id="miLista1" onChange={handleLista1}>
            {detDetalleCi}
          </select>
        }
      </div>
    )
  }else{
    elemento.ciudades.forEach((elemento1, _id) => {
      if(elemento1.codigoCiudad===codigoCiudadUA){
        let niv3Det = []
        niv3Det.push(elemento1)
        detDetalleCi = niv3Det.map((elemento, i) => <DetDetalleSelCi styles={styles} elemento={elemento} key={i} />);
      }
    })
    return (
      <div>
        {selecc  &&
          <select style={styles.input} className="ui simple selection dropdown fluid" name="ciudad" id="miLista1" onChange={handleLista1}>
            {detDetalleCi}
          </select>
        }
        {!selecc  &&
          <select style={styles.input} className="ui simple selection dropdown fluid" name="ciudad" id="miLista1" onChange={handleLista1}>
            {detDetalleCi}
          </select>
        }
      </div>
    )
  }
};

const ListaCi = ({styles, handleLista1, list, argsSelDpto, codigoCiudadUA}) => {
  var detalleCi = []
  let selecc = true
  list.forEach((elemento, _id) => {
    if(elemento.codigoDpto===argsSelDpto.codigoDpto){
      let niv2Det = []
      niv2Det.push(elemento)
      detalleCi = niv2Det.map((elemento, _id) => <DetalleSelCi styles={styles} elemento={elemento}
        key={elemento._id} handleLista1={handleLista1} codigoCiudadUA={codigoCiudadUA}/>);
      if(elemento.ciudades.length===1){
        selecc = false
      }
    }
  })

  return(
    <div>
      {(!argsSelDpto.descrDpto||argsSelDpto.descrDpto==="Seleccionar...")&&selecc ?
        <select style={styles.input} className="ui simple selection dropdown fluid" name="ciudad" id="miLista1C" onChange={handleLista1}>
          <option value="">Seleccionar...</option>
          {detalleCi}
        </select>
      :
        <div>
          {detalleCi}
        </div>
      }
    </div>
  )
};
//Fin dropdown CIUDADES
//dropdown ZONAS => solo zonas de la ciudad seleccionada
const DetalleSelZo = props => {
  return (
      <option>{props.elemento.nombreZona}</option>
  )
};

const ListaZo = ({styles, argsSelDpto}) => {
  let lisZona = []
  lisZona.push(argsSelDpto)
  const detDetalleZo = lisZona.map((elemento, i) => <DetalleSelZo elemento={elemento} key={i} />);
    return(
        <div>
            <select style={styles.input} className="ui simple selection dropdown fluid" name="dpto" id="miLista2">
              {detDetalleZo}
            </select>
        </div>
    )
};
//Fin dropdown ZONAS
//dropdown BARRIOS => solo barrios de la zona seleccionada
const DetDetalleSelBa = props => {
  return(
      <option dato1={props.elemento.barrio.codigoTipoDocT + "/" + props.elemento.codigoZona}
              dato2={props.elemento.barrio.numeroDocumT + "/" + props.elemento.nombreZona}
              dato3={props.elemento.barrio.descrRecursoT} dato4={props.elemento.barrio.codigoTipoDocR}
              dato5={props.elemento.barrio.numeroDocumR} dato6={props.elemento.barrio.descrRecursoR}
              value={props.elemento.barrio.codigoBarrio}>{props.elemento.barrio.nombreBarrio}</option>
  )
}

const DetalleSelBa = ({styles, elemento, handleLista3}) => {
  var detDetalleBa = []
  var niv5Det = []
  elemento.forEach((elemento1, i) => {
      niv5Det.push(elemento1)
  })
  detDetalleBa = niv5Det.map((elemento, i) => <DetDetalleSelBa styles={styles} elemento={elemento} key={i} />);
  return (
      <select style={styles.input} className="ui simple selection dropdown fluid" name="dpto" id="miLista3" onChange={handleLista3}>
          <option value="">Seleccionar...</option>
          {detDetalleBa}
      </select>
  )
};

const ListaBa = ({styles, handleLista3, list, argsSelDpto}) => {
  var detalleBa = []
  list.forEach((elemento, _id) => {
    if(argsSelDpto.codigoDpto && elemento.ciudades.length>0 && elemento.codigoDpto===argsSelDpto.codigoDpto){
      elemento.ciudades.forEach((elemento1, i) => {
        if(argsSelDpto.codigoCiudad && elemento1.codigoCiudad===argsSelDpto.codigoCiudad){
          if(argsSelDpto.codigoDpto && elemento1.zonas.length>0 && elemento.codigoDpto===argsSelDpto.codigoDpto){
            let lisBarr = []
            elemento1.zonas.forEach((elemento2, ii) => {
              elemento2.barrios.forEach((elemento3, ii) => {
                lisBarr.push({barrio: elemento3, codigoZona: elemento2.codigoZona,
                              nombreZona: elemento2.nombreZona})
              })
            })
            lisBarr = _.orderBy(lisBarr, ['barrio.nombreBarrio'])

            let niv4Det = []
            niv4Det.push(lisBarr)
            detalleBa = niv4Det.map((elemento, i) => <DetalleSelBa styles={styles} elemento={elemento} key={i} handleLista3={handleLista3}/>);
          }
        }
      })
    }
  })
  let miLista = document.getElementById("miLista3");
  if(miLista){
    if(argsSelDpto.nombreBarrio&&miLista.options[miLista.selectedIndex].text!==argsSelDpto.nombreBarrio)
    miLista.options.selectedIndex = 0
  }
  return(
    <div>
      {!argsSelDpto.descrDpto||!argsSelDpto.nombreCiudad||
        argsSelDpto.descrDpto==="Seleccionar..."||argsSelDpto.nombreCiudad==="Seleccionar..." ?
          <select style={styles.input} className="ui simple selection dropdown fluid" name="dpto" id="miLista3B" onChange={handleLista3}>
            <option value="">Seleccionar...</option>
            {detalleBa}
          </select>
      :
        <div>
          {detalleBa}
        </div>
      }
    </div>
  )
};
//Fin dropdown BARRIOS

  const ListaDirAct = ({linea0, linea1, linea2, linea3, linea4}) => {
    if(!linea0){
      return(
        <tbody className=''>
          <tr className=''>
            <td className=''>{linea1}</td>
          </tr>
          <tr className=''>
            <td className=''>{linea2}</td>
          </tr>
          <tr className=''>
            <td className=''>{linea3}</td>
          </tr>
          <tr className=''>
            <td className=''>{linea4}</td>
          </tr>
        </tbody>
      )
    }else{
      return(
        <tbody className=''>
          <tr className=''>
            <td className=''>Estrato: {linea0}</td>
          </tr>
          <tr className=''>
            <td className=''>{linea1}</td>
          </tr>
          <tr className=''>
            <td className=''>{linea2}</td>
          </tr>
          <tr className=''>
            <td className=''>{linea3}</td>
          </tr>
          <tr className=''>
            <td className=''>{linea4}</td>
          </tr>
        </tbody>
      )
    }
  };

const DetListInf = ({elemento, handleChange}) => {
    return(
      <tr className=''>
        <td className='collapsing'>
          <div className='ui fitted slider checkbox'>
            <input type='checkbox' name='estadoInf' id={elemento._id} checked={elemento.estadoLis} onChange={(ev)=>handleChange(ev, elemento)}/>
            <label />
          </div>
        </td>
        <td className=''>{elemento.codigoTipoDoc}</td>
        <td className=''>{elemento.numeroDocum}</td>
        <td className=''>{elemento.descrRecurso}</td>
        <td className=''>{elemento.descrTipoRec}</td>
      </tr>
    )
  };
  
  const ListaInf = ({list, handleChange}) => {
    const nivelDetInf = list.map((elemento, _id) => <DetListInf elemento={elemento} handleChange={handleChange} key={elemento._id}/>);
    return(
      <tbody className=''>
        {nivelDetInf}
      </tbody>
    )
  };

  const DetListSup = ({elemento, handleChange}) => {
    return(
      <tr className=''>
        <td className='collapsing'>
          <div className='ui fitted slider checkbox'>
            <input type='checkbox' name='estadoSup' id={elemento._id} checked={elemento.estadoLis} onChange={(ev)=>handleChange(ev, elemento)}/>
            <label />
          </div>
        </td>
        <td className=''>{elemento.codigoTipoDoc}</td>
        <td className=''>{elemento.numeroDocum}</td>
        <td className=''>{elemento.descrRecurso}</td>
        <td className=''>{elemento.descrTipoRec}</td>
      </tr>
    )
  };
  
  const ListaSup = ({list, handleChange}) => {
    const nivelDetSup = list.map((elemento, _id) => <DetListSup elemento={elemento} handleChange={handleChange} key={elemento._id}/>);
    return(
      <tbody className=''>
        {nivelDetSup}
      </tbody>
    )
  };

class VerOS2 extends React.Component {
    state={
        argsDocum: {numeroOS: this.props.list7[0].numeroOS,
                    impresa: this.props.list7[0].impresa,
                    descrTipoOS: this.props.list7[0].tipoos.descrTipoOS,
                    ptosAdic: this.props.list7[0].ptosAdic,
                    descrCategOST: this.props.list7[0].descrCategOST?this.props.list7[0].descrCategOST:"",
                    observacAB: this.props.list7[0].observacAB,
                    observacCA: "",
                    observacCE: "",
                    tipoOSDirAnt: "Seleccionar...",
                    observacABOS: "",
                    codigoMarquilla: this.props.list7[0].codigoMarquilla?this.props.list7[0].codigoMarquilla:"",
                    descrNodo: this.props.list7[0].descrNodo?this.props.list7[0].descrNodo:"",
                    codigoPaquete: this.props.list7[0].codigoPaquete?this.props.list7[0].codigoPaquete:"",
                    descrPaquete: this.props.list7[0].descrPaquete?this.props.list7[0].descrPaquete:"",
                    noFactOSAb: this.props.cliente.noFactOSAb?this.props.cliente.noFactOSAb:"",
                    descrClasifOST: this.props.list7[0].descrClasifOST?this.props.list7[0].descrClasifOST:null,
                    estadoCierre: null,
                    codigoTipoDocV: this.props.list7[0].codigoTipoDocV?this.props.list7[0].codigoTipoDocV:null,
                    numeroDocumV: this.props.list7[0].numeroDocumV?this.props.list7[0].numeroDocumV:null,
                    descrRecursoV: this.props.list7[0].descrRecursoV?this.props.list7[0].descrRecursoV:"Seleccionar...",
                    fechaEjec: this.props.list7[0].fechaEjec.substr(0, 10),
                    fechaFra: this.props.list7[0].fechaFra.substr(0, 10),
                    valorCpto1: 0,
                    valorCpto2: 0,
                    valorCpto3: 0,
                    descrOtrosPagCl: "Seleccionar...", codigoImpto: "", descrImpto: "",
                    porcImpto: "", descrClaseServ: "", stValor: 0,
                    descrEstrato: "Seleccionar...",
                    _id: this.props.list7[0]._id},
                    checkNoFactOsAb: this.props.cliente.noFactOSAb?this.props.cliente.noFactOSAb:false,
                    checkDiasRestoMes: (this.props.empresa.modeloFactura!=="1"&&this.props.empresa.empresaArchFE!=="conectic"&&this.props.empresa.empresaArchFE!=="supercable")?true
                      :(new Date()).getUTCDate()<32?false:true,
        StLinea1DN: {descrTipoVia1: this.props.list7[0].direccion?this.props.list7[0].direccion.descrTipoVia1:"",
                    numeroTipoVia1: this.props.list7[0].direccion?this.props.list7[0].direccion.numeroTipoVia1:"",
                    descrTipoVia2: this.props.list7[0].direccion?this.props.list7[0].direccion.descrTipoVia2:"",
                    numeroTipoVia2: this.props.list7[0].direccion?this.props.list7[0].direccion.numeroTipoVia2:"",
                    numeroTipoVia2F: this.props.list7[0].direccion?this.props.list7[0].direccion.numeroTipoVia2F:"",
                    descrTipoUnd1: this.props.list7[0].direccion?this.props.list7[0].direccion.descrTipoUnd1:"",
                    numeroTipoUnd1: this.props.list7[0].direccion?this.props.list7[0].direccion.numeroTipoUnd1:"",
                    descrTipoUnd2: this.props.list7[0].direccion?this.props.list7[0].direccion.descrTipoUnd2:"",
                    numeroTipoUnd2: this.props.list7[0].direccion?this.props.list7[0].direccion.numeroTipoUnd2:""},
        StLinea2DN: {descrTiUndMat: this.props.list7[0].direccion?this.props.list7[0].direccion.descrTiUndMat:"",
                    descrUndMat: this.props.list7[0].direccion?this.props.list7[0].direccion.descrUndMat:""},
        StLineaDNDM: {dirMayorOS: this.props.list7[0].dirmayor?this.props.list7[0].dirmayor:""},
        descrEstratoDN: this.props.list7[0].descrEstrato?this.props.list7[0].descrEstrato:"",
        descrEstratoDA: this.props.cliente.descrEstrato?this.props.cliente.descrEstrato:"",
        stListServTarAct: this.props.cliente.tarifa?this.props.cliente.tarifa:{},
        stlistServTarNva: this.props.list7[0].tarifa?this.props.list7[0].tarifa:{}, imptosCF: [],
        codigoTarifaAct: this.props.cliente.tarifa?this.props.cliente.tarifa.codigoTarifa:"",
        codigoTarifaNva: this.props.list7[0].tarifa?this.props.list7[0].tarifa.codigoTarifa:"",

        stListServOfAct: this.props.cliente.oferta?this.props.cliente.oferta:{},
        stlistServOfNva: this.props.list7[0].oferta?this.props.list7[0].oferta:{},
        codigoOfertaAct: this.props.cliente.oferta?this.props.cliente.oferta.codigoOferta:"",
        codigoOfertaNva: this.props.list7[0].oferta?this.props.list7[0].oferta.codigoOferta:"",

        stListEquiCliAct: this.props.cliente.equipos?this.props.cliente.equipos:[],
        // stlistEquiCliNva: this.props.list7[0].equipos?this.props.list7[0].equipos:[],
        // numeroSerieAct: this.props.cliente.equipos?this.props.cliente.equipos.numeroSerie:"",
        // numeroSerieNva: this.props.list7[0].equipos?this.props.list7[0].equipos.numeroSerie:"",

        ctrlEntr: 0,

        codigoDpto: {codigoDpto: this.props.cliente.dirmayor?this.props.cliente.dirmayor.codigoDpto:"",
        descrTipoVia1: this.props.cliente.direccion?this.props.cliente.direccion.descrTipoVia1:""},
        listInf: this.props.lisInf, listSup: this.props.lisSup,
        listServTar: [], listServ: [], listEquiCli: [], listEqui: [], listServOf: [],
        errors: this.props.errors, checkTodo: true,
        confirmaAct: false, open: false, txtBtnAgrEq: "AGREGAR EQUIPO", stNumeroSerie: "", stMac: "",
        listCliDirAct: [], listCliDirNva: [],
        stlistEquiCliNva: this.props.cliente.equipos&&!this.props.list7[0].equipos
                      ?
                      this.props.cliente.equipos.map((elemento, i) => ({
                        numeroSerie: elemento.numeroSerie, mac: elemento.mac, accion: "IGUAL",
                          _idClaseEqu: elemento.claseequ._id, codigoClaseEqu: elemento.claseequ.codigoClaseEqu,
                          descrClaseEqu: elemento.claseequ.descrClaseEqu, _idMarcaEqu: elemento.marcaequ._id,
                          codigoMarcaEqu: elemento.marcaequ.codigoMarcaEqu, descrMarcaEqu: elemento.marcaequ.descrMarcaEqu,
                          _idFabriEqu: elemento.fabriequ._id, codigoFabriEqu: elemento.fabriequ.codigoFabriEqu,
                          descrFabriEqu: elemento.fabriequ.descrFabriEqu,
                          _id: i, estadoSelecc: true
                        }))                      
                      :this.props.list7[0].equipos?this.props.list7[0].equipos:[]
      }

    ordenarArrayAsc = (array, campo) => {
        array.sort(function (a, b) {
           return a[campo] > b[campo];
        });
      }

    handleRefresh = () => {
        let arraySup=this.state.listSup
        let arrayInf=this.state.listInf
    
        arrayInf.forEach((elemento, _id) => {
          if(elemento.estadoLis===true){
            arraySup.push({_id: elemento._id, codigoTipoDoc: elemento.codigoTipoDoc,
                numeroDocum: elemento.numeroDocum, descrRecurso: elemento.descrRecurso, _idTipoRec: elemento._idTipoRec,
                descrTipoRec: elemento.descrTipoRec, areaAprovech: elemento.areaAprovech,
                estadoLis: true});
              }
        })

        let arrayInf1 = arrayInf.filter(item => item.estadoLis===true);
        arrayInf1.forEach((elemento1, _id) => {
          arrayInf.forEach((elemento, _id) => {
            if(elemento.estadoLis===true && elemento1._id===elemento._id){
              const indexLis = arrayInf.findIndex( servicio => servicio._id === elemento._id );
              arrayInf.splice(indexLis, 1);
            }
          })
        })
    
        arraySup.forEach((elemento, _id) => {
          if(elemento.estadoLis===false){
            arrayInf.push({_id: elemento._id, codigoTipoDoc: elemento.codigoTipoDoc,
                numeroDocum: elemento.numeroDocum, descrRecurso: elemento.descrRecurso, _idTipoRec: elemento._idTipoRec,
                descrTipoRec: elemento.descrTipoRec, areaAprovech: elemento.areaAprovech,
                estadoLis: false});
              }
        })
        
        arrayInf1 = arraySup.filter(item => item.estadoLis===false);
        arrayInf1.forEach((elemento1, _id) => {
          arraySup.forEach((elemento, _id) => {
            if(elemento.estadoLis===false && elemento1._id===elemento._id){
              const indexLis = arraySup.findIndex( servicio => servicio._id === elemento._id );
              arraySup.splice(indexLis, 1);
            }
          })
        })
    
        this.ordenarArrayAsc(arraySup, 'descrRecurso')
        this.ordenarArrayAsc(arrayInf, 'descrRecurso')
    
        this.setState({listSup: arraySup})
        this.setState({listInf: arrayInf})
        this.setState({open: false})
        this.setState({errors: []})
      }

    handleChange = (ev, elemento) => {
      // console.log(ev.target.name)
      if(ev.target.name === "valorCpto1"||ev.target.name === "valorCpto2"||ev.target.name === "valorCpto3"){
        const argsDocum = this.state.argsDocum
        argsDocum[ev.target.name] = ev.target.value 
        this.setState({argsDocum});
      }
      if(ev.target.name === "stValor"){
        const argsDocum = this.state.argsDocum
        let stValor = parseInt(ev.target.value, 10)
        argsDocum[ev.target.name] = stValor 
        this.setState({argsDocum});
      }

      if(ev.target.name === "checkDiasRestoMes"){
        // const argsDocum = this.state.argsDocum
        // argsDocum[ev.target.name] = ev.target.checked
        // this.setState({argsDocum});
        this.setState({checkDiasRestoMes: ev.target.checked});
      }
      if(this.props.permiteUpdate&&ev.target.name === "checkNoFactOsAb"){
      // if(ev.target.name === "checkNoFactOsAb"){
        this.setState({checkNoFactOsAb: ev.target.checked});
      }
  
      if (this.props.permiteClose||this.props.permiteCancel){
        const argsDocum = this.state.argsDocum
        if(ev.target.name === "venta"){
          let miLista = document.getElementById("miListaV");
          argsDocum['descrRecursoV'] = miLista.options[miLista.selectedIndex].text
          if(miLista.options[miLista.selectedIndex].text==="Seleccionar..."){
            argsDocum['numeroDocumV'] = null
            argsDocum['codigoTipoDocV'] = null
          }else{
            argsDocum['numeroDocumV'] = ev.target.value
            argsDocum['codigoTipoDocV'] = miLista.options[miLista.selectedIndex].attributes[0].value
          }
          this.setState({argsDocum});
        }
        if(ev.target.name === "tipoOSDirAnt"){
          let miLista = document.getElementById("miListaTOS");
          argsDocum['tipoOSDirAnt'] = miLista.options[miLista.selectedIndex].text
          // if(miLista.options[miLista.selectedIndex].text==="Seleccionar..."){
          //   argsDocum['tipoOSDirAnt'] = null
          // }else{
          //   argsDocum['tipoOSDirAnt'] = ev.target.value
          // }
          this.setState({argsDocum});
        }
        if(ev.target.name === "clasifos"){
          let miLista = document.getElementById("miListaClOS");
          // console.log(miLista.options[miLista.selectedIndex].text)
          argsDocum['descrClasifOST'] = miLista.options[miLista.selectedIndex].text
          if(miLista.options[miLista.selectedIndex].text==="Seleccionar..."){
            argsDocum['descrClasifOST'] = null
          }else{
            argsDocum['descrClasifOST'] = ev.target.value
          }
          this.setState({argsDocum});
        }
        if(ev.target.name === "nodos"){
          let miLista = document.getElementById("miListaNodo");
          // console.log(miLista.options[miLista.selectedIndex].text)
          argsDocum['descrNodo'] = miLista.options[miLista.selectedIndex].text
          if(miLista.options[miLista.selectedIndex].text==="Seleccionar..."){
            argsDocum['descrNodo'] = null
          }else{
            argsDocum['descrNodo'] = ev.target.value
          }
          this.setState({argsDocum});
        }

        if(!argsDocum.codigoPaquete&&this.props.allPaquete.allPaquete.length===1){
          argsDocum['codigoPaquete'] =  this.props.allPaquete.allPaquete[0].codigoPaquete
          argsDocum['descrPaquete'] = this.props.allPaquete.allPaquete[0].descrPaquete
        }    
        if(ev.target.name === "paquete"){
          let miLista = document.getElementById("miListaPaq");
          // console.log(miLista.options[miLista.selectedIndex].text)
          // argsDocum['descrPaquete'] = miLista.options[miLista.selectedIndex].text
          if(miLista.options[miLista.selectedIndex].text==="Seleccionar..."){
            argsDocum['codigoPaquete'] = null
            argsDocum['descrPaquete'] = null
          }else{
            argsDocum['codigoPaquete'] = ev.target.value
            argsDocum['descrPaquete'] = miLista.options[miLista.selectedIndex].text
          }
          this.setState({argsDocum});
        }

        if(ev.target.name === "observacCE"||ev.target.name === "observacABOS"||ev.target.name === "observacCA"||ev.target.name === "codigoMarquilla"){
          argsDocum[ev.target.name] = ev.target.value 
          this.setState({argsDocum});
        }
        if(ev.target.name === "estadoCierre"){
          let miLista = document.getElementById("miListaEC");
          argsDocum['estadoCierre'] = miLista.options[miLista.selectedIndex].text
          if(miLista.options[miLista.selectedIndex].text==="Seleccionar..."){
            argsDocum['estadoCierre'] = null
          }else{
            argsDocum['estadoCierre'] = ev.target.value
          }
          this.setState({argsDocum});
        }
        // console.log(argsDocum)
      }

      if (this.props.permiteUpdate){
        this.setState({confirmaAct: false})
        // console.log(ev.target.name)
        // console.log(ev.target)
        if(ev.target.name === "ptosAdic"||ev.target.name === "observacAB"||ev.target.name === "fechaEjec"||ev.target.name === "fechaFra"){
            const argsDocum = this.state.argsDocum
            argsDocum[ev.target.name] = ev.target.value 
            this.setState({argsDocum});
        }
        if(ev.target.name === "estadoSup"){
          let listSup=this.state.listSup
          const indexLis = listSup.findIndex( recurso => recurso._id === ev.target.id );
          if(ev.target.name === "estadoSup"){
            if(elemento.estadoLis===false){
              listSup[indexLis].estadoLis = true
            }else{
              listSup[indexLis].estadoLis = false
            }
          }
          this.setState({listSup});
        }
        if(ev.target.name === "estadoInf"){
          let listInf=this.state.listInf
          const indexLis = listInf.findIndex( recurso => recurso._id === ev.target.id );
          if(elemento.estadoLis===false){
            listInf[indexLis].estadoLis = true
          }else{
            listInf[indexLis].estadoLis = false
          }
          this.setState({listInf});
        }        
        if(ev.target.name === "descrCategOST"){
          const argsDocum = this.state.argsDocum
          var miLista = document.getElementById("miListaCateg");
          argsDocum[ev.target.name] = miLista.options[miLista.selectedIndex].text 
          this.setState({argsDocum});
          // console.log(argsDocum)
        }
      }
    }

    handleChangeTar = (ev, elemento, imptosCF) => {
      // console.log(ev.target.name)
      // console.log(elemento)
      // console.log(this.state.listServTar)
      if(ev.target.name === "estadoSeleccPpal" ||
          ev.target.name === "numeroServicios" ||
          ev.target.name === "valorServicios" ||
          ev.target.name === "estadoSeleccTodo"
        ){
        let listServTar=this.state.listServTar
        if(ev.target.name === "estadoSeleccTodo"){
          let checkTodo = this.state.checkTodo

          listServTar.forEach((elemento1, i) => {
            if(checkTodo===false){
              listServTar[i].estadoSelecc = true
            }else{
              listServTar[i].estadoSelecc = false
            }
          })

          if(checkTodo===false){
            checkTodo = true
          }else{
            checkTodo = false
          }

          this.setState({checkTodo});
        }
        const indexSearch = listServTar.findIndex( servicio => servicio.codigoServicio === ev.target.id );
        if(ev.target.name === "estadoSeleccPpal"){
          if(elemento.estadoSelecc===false){
            listServTar[indexSearch].estadoSelecc = true
          }else{
            listServTar[indexSearch].estadoSelecc = false
          }
        }
        if(ev.target.name === "numeroServicios"){
          listServTar[indexSearch].numeroServicios = ev.target.value
          let valorS = null
          let servFinal = 0
          let imptosCF = []
          if(Number(ev.target.value)>=Number(elemento.rango1NumServValorIni)){
            if(Number(ev.target.value)>Number(elemento.rango1NumServValorFin)){
              valorS = elemento.rango1NumServValorFin * elemento.rango1Valor
            }else{
              valorS = ev.target.value * elemento.rango1Valor
            }
            servFinal = elemento.rango1NumServValorFin
          }
          if(elemento.rango2NumServValorIni!==null&&Number(ev.target.value)>=Number(elemento.rango2NumServValorIni)){
            if(Number(ev.target.value)>Number(elemento.rango2NumServValorFin)){
              valorS += (elemento.rango2NumServValorFin - servFinal) * elemento.rango2Valor
            }else{
              valorS += (ev.target.value - servFinal) * elemento.rango2Valor
            }
            servFinal = elemento.rango2NumServValorFin
          }
          if(elemento.rango3NumServValorIni!==null&&Number(ev.target.value)>=Number(elemento.rango3NumServValorIni)){
            if(Number(ev.target.value)>Number(elemento.rango3NumServValorFin)){
              valorS += (elemento.rango3NumServValorFin - servFinal) * elemento.rango3Valor
            }else{
              valorS += (ev.target.value - servFinal) * elemento.rango3Valor
            }
          }
          if(valorS!==null&&valorS!==''){
            let valorI = 0
            elemento.imptos.forEach((elemento1, _id) => {
              valorI += Math.round(valorS * (elemento1.porcImpto / 100))
              imptosCF.push({codigoServicio: elemento.codigoServicio, _id: elemento1._id, codigoImpto: elemento1.codigoImpto,
                descrImpto: elemento1.descrImpto, porcImpto: elemento1.porcImpto,
                valorImpto: Math.round(valorS * (elemento1.porcImpto / 100))})
            })
            valorS = (Math.round((valorS + valorI) / 10) * 10) - valorI
            listServTar[indexSearch].valorAntesImptos = valorS
            valorS += valorI
            this.setState({imptosCF});
          }
          listServTar[indexSearch].valorServicios = valorS
          listServTar[indexSearch].imptos = imptosCF
          // console.log(listServTar)
        }

        this.setState({listServTar});
      }
  
      if(ev.target.name === "estadoSelecc"){
        let listServ=this.state.listServ
        const indexSearch = listServ.findIndex( servicio => servicio.codigoServicio === ev.target.id );
        if(elemento.estadoSelecc===false){
          listServ[indexSearch].estadoSelecc = true
        }else{
          listServ[indexSearch].estadoSelecc = false
        }
        this.setState({listServ});
      }
    }

    handleChangeEqu = (ev, elemento, listAsig) => {
      if(ev.target.name === "numeroSerie"){
        this.setState({stNumeroSerie: ev.target.value});
      }
      if(ev.target.name === "mac"){
        this.setState({stMac: ev.target.value});
      }

      if(ev.target.name === "estadoSeleccPpal"){
        let listEquiCli=listAsig
        const indexSearch = listEquiCli.findIndex( serie => serie.numeroSerie === ev.target.id );
        if(ev.target.name === "estadoSeleccPpal"){
          if(elemento.estadoSelecc===false){
            listEquiCli[indexSearch].estadoSelecc = true
          }else{
            listEquiCli[indexSearch].estadoSelecc = false
          }
        }
        this.setState({listEquiCli});
      }

      if(ev.target.name === "estadoSelecc"){
        let listEqui=listAsig
        const indexSearch = listEqui.findIndex( serie => serie.numeroSerie === ev.target.id );
        if(elemento.estadoSelecc===false){
          listEqui[indexSearch].estadoSelecc = true
        }else{
          listEqui[indexSearch].estadoSelecc = false
        }
        this.setState({listEqui});
      }
    }

    handleAgrEquipo = (list10, listEquiCliAsig) => {
      let indexSearch = list10.findIndex( serie => serie.numeroSerie === this.state.stNumeroSerie );
      let agrEquipo = true
      if(indexSearch===-1){
        indexSearch = list10.findIndex( mac => mac.mac === this.state.stMac );
        if(indexSearch===-1){
          this.setState({txtBtnAgrEq: "AGREGAR EQUIPO => !! EQUIPO INVALIDO !!"});
          agrEquipo = false
        }
      }
      if(agrEquipo){
        let indexSearch1 = listEquiCliAsig.findIndex( serie => serie.numeroSerie === list10[indexSearch].numeroSerie );
        if(indexSearch1!==-1){
          this.setState({txtBtnAgrEq: "AGREGAR EQUIPO => !! EQUIPO YA AGREGADO !!"});
          agrEquipo = false
        }
      }
      if(agrEquipo){
        let listEquiCli = listEquiCliAsig
        let numS = new Date().getTime();
        listEquiCli.push({numeroSerie: list10[indexSearch].numeroSerie, mac: list10[indexSearch].mac,
          _idClaseEqu: list10[indexSearch].claseequ._id, codigoClaseEqu: list10[indexSearch].claseequ.codigoClaseEqu,
          descrClaseEqu: list10[indexSearch].claseequ.descrClaseEqu, _idMarcaEqu: list10[indexSearch].marcaequ._id,
          codigoMarcaEqu: list10[indexSearch].marcaequ.codigoMarcaEqu, descrMarcaEqu: list10[indexSearch].marcaequ.descrMarcaEqu,
          _idFabriEqu: list10[indexSearch].fabriequ._id, codigoFabriEqu: list10[indexSearch].fabriequ.codigoFabriEqu,
          descrFabriEqu: list10[indexSearch].fabriequ.descrFabriEqu,
          _id: numS, estadoSelecc: true
        });
        this.setState({listEquiCli})

        this.setState({txtBtnAgrEq: "AGREGAR EQUIPO"});
        this.setState({stNumeroSerie: ""});
        this.setState({stMac: ""});
      }
    }

    handleRefreshEqu = (listEquiCliAsig, listEquiAsig) => {
      // console.log(listEquiCliAsig)

      let arrayTabla1=listEquiCliAsig
      let arrayTabla2=listEquiAsig
  // console.log(arrayTabla1)
  // console.log(arrayTabla2)
      let numS = new Date().getTime();
      // let numS = arrayTabla1.length + 2
      // console.log(numS)
      arrayTabla2.forEach((elemento, i) => {
        if(elemento.estadoSelecc===true){
          numS = numS + i + 1
          // console.log(numS)
          arrayTabla1.push({numeroSerie: elemento.numeroSerie, mac: elemento.mac,
            _idClaseEqu: elemento._id, codigoClaseEqu: elemento.codigoClaseEqu,
            descrClaseEqu: elemento.descrClaseEqu, _idMarcaEqu: elemento._id,
            codigoMarcaEqu: elemento.codigoMarcaEqu, descrMarcaEqu: elemento.descrMarcaEqu,
            _idFabriEqu: elemento._id, codigoFabriEqu: elemento.codigoFabriEqu,
            descrFabriEqu: elemento.descrFabriEqu,
            _id: numS, estadoSelecc: true
          });
        }
      })
  
      let arrayTabla21 = arrayTabla2.filter(item => item.estadoSelecc===true);
      arrayTabla21.forEach((elemento1, _id) => {
        arrayTabla2.forEach((elemento, _id) => {
          if(elemento.estadoSelecc===true && elemento1.numeroSerie===elemento.numeroSerie){
            const indexSearch = arrayTabla2.findIndex( serial => serial.numeroSerie === elemento.numeroSerie );
            arrayTabla2.splice(indexSearch, 1);
          }
        })
      })

      arrayTabla1.forEach((elemento, _id) => {
        if(elemento.estadoSelecc===false){
          arrayTabla2.push({numeroSerie: elemento.numeroSerie, mac: elemento.mac,
            _idClaseEqu: elemento._id, codigoClaseEqu: elemento.codigoClaseEqu,
            descrClaseEqu: elemento.descrClaseEqu, _idMarcaEqu: elemento._id,
            codigoMarcaEqu: elemento.codigoMarcaEqu, descrMarcaEqu: elemento.descrMarcaEqu,
            _idFabriEqu: elemento._id, codigoFabriEqu: elemento.codigoFabriEqu,
            descrFabriEqu: elemento.descrFabriEqu,
            _id: elemento._id, estadoSelecc: false
          });
        }
      })
      
      arrayTabla21 = arrayTabla1.filter(item => item.estadoSelecc===false);
      arrayTabla21.forEach((elemento1, _id) => {
        arrayTabla1.forEach((elemento, _id) => {
          if(elemento.estadoSelecc===false && elemento1.numeroSerie===elemento.numeroSerie){
            const indexSearch = arrayTabla1.findIndex( serial => serial.numeroSerie === elemento.numeroSerie );
            arrayTabla1.splice(indexSearch, 1);
          }
        })
      })
  // console.log(arrayTabla1)
  // console.log(arrayTabla2)

      this.ordenarArrayAsc(arrayTabla1, 'numeroSerie')
      this.ordenarArrayAsc(arrayTabla2, 'numeroSerie')
  
      this.setState({listEquiCli: arrayTabla1})
      this.setState({listEqui: arrayTabla2})
      this.setState({open: false})
      this.setState({errors: []})
    }

    handleRefreshTar = () => {
      let arrayTabla1=this.state.listServTar
      let arrayTabla2=this.state.listServ
      // console.log(arrayTabla1)
      // console.log(arrayTabla2)
      // let numS = arrayTabla1.length + 2
      arrayTabla2.forEach((elemento, i) => {
        if(elemento.estadoSelecc===true){
          let numS = new Date().getTime();
          numS = numS + i + 1
          // console.log(numS)
          // console.log(elemento)
          let valorServicios = 0
          let valorAntesImptos = 0
          let imptosCF = []
          if(elemento.rango1Valor){
            valorServicios = Number(elemento.rango1Valor)
            // if(valorServicios!==null&&valorServicios!==''){
            //   valorServicios = 0
            // }
            let valorI = 0
            elemento.imptos.forEach((elemento1, _id) => {
              valorI += Math.round(valorServicios * (elemento1.porcImpto / 100))
              imptosCF.push({codigoServicio: elemento.codigoServicio, _id: elemento1._id, codigoImpto: elemento1.codigoImpto,
                descrImpto: elemento1.descrImpto, porcImpto: elemento1.porcImpto,
                valorImpto: Math.round(valorServicios * (elemento1.porcImpto / 100))})        
            })
            valorServicios = (Math.round((valorServicios + valorI) / 10) * 10) - valorI
            valorAntesImptos = valorServicios
            valorServicios += valorI
          }else{
            imptosCF = elemento.imptos
          }
          arrayTabla1.push({codigoTarifa: elemento.codigoTarifa, descrTarifa: elemento.descrTarifa,
            cicloFact: elemento.cicloFact,
            codigoServicio: elemento.codigoServicio, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
            _idSubclaseServ: elemento._idSubclaseServ, codigoSubclaseServ: elemento.codigoSubclaseServ,
            descrSubclaseServ: elemento.descrSubclaseServ, _idClaseServ: elemento._idClaseServ,
            codigoClaseServ: elemento.codigoClaseServ, descrClaseServ: elemento.descrClaseServ,
            velEfecDownstream: elemento.velEfecDownstream, velEfecUpstream: elemento.velEfecUpstream,
            codigoTipoTec: elemento.codigoTipoTec, descrTipoTec: elemento.descrTipoTec,
            colorServicio: elemento.colorServicio,
            rango1NumServValorIni: elemento.rango1NumServValorIni, rango1NumServValorFin: elemento.rango1NumServValorFin,
            rango1Valor: elemento.rango1Valor, rango2NumServValorIni: elemento.rango2NumServValorIni,
            rango2NumServValorFin: elemento.rango2NumServValorFin, rango2Valor: elemento.rango2Valor,
            rango3NumServValorIni: elemento.rango3NumServValorIni, rango3NumServValorFin: elemento.rango3NumServValorFin,
            rango3Valor: elemento.rango3Valor,
            numeroServicios: elemento.numeroServicios!==undefined?elemento.numeroServicios:'1',
            valorServicios: elemento.valorServicios!==undefined?elemento.valorServicios:valorServicios,
            valorAntesImptos: elemento.valorAntesImptos!==undefined?elemento.valorAntesImptos:valorAntesImptos,
            _id: numS, estadoSelecc: true, imptos: imptosCF
          });
            }
      })
      // console.log(arrayTabla1)
      let arrayTabla21 = arrayTabla2.filter(item => item.estadoSelecc===true);
      arrayTabla21.forEach((elemento1, _id) => {
        arrayTabla2.forEach((elemento, _id) => {
          if(elemento.estadoSelecc===true && elemento1.codigoServicio===elemento.codigoServicio){
            const indexSearch = arrayTabla2.findIndex( servicio => servicio.codigoServicio === elemento.codigoServicio );
            arrayTabla2.splice(indexSearch, 1);
          }
        })
      })

      arrayTabla1.forEach((elemento, i) => {
        if(elemento.estadoSelecc===false){
          // console.log(elemento)
          let numS = new Date().getTime();
          numS = numS + i + 1
          let valorServicios = 0
          let valorAntesImptos = 0
          let imptosCF = []
          if(elemento.rango1Valor){
            valorServicios = Number(elemento.rango1Valor)
            // if(valorServicios!==null&&valorServicios!==''){
            //   valorServicios = 0
            // }
            let valorI = 0
            elemento.imptos.forEach((elemento1, _id) => {
              valorI += Math.round(valorServicios * (elemento1.porcImpto / 100))
              imptosCF.push({codigoServicio: elemento.codigoServicio, _id: elemento1._id, codigoImpto: elemento1.codigoImpto,
                descrImpto: elemento1.descrImpto, porcImpto: elemento1.porcImpto,
                valorImpto: Math.round(valorServicios * (elemento1.porcImpto / 100))})        
            })
            valorServicios = (Math.round((valorServicios + valorI) / 10) * 10) - valorI
            valorAntesImptos = valorServicios
            valorServicios += valorI
          }else{
            imptosCF = elemento.imptos
          }
          arrayTabla2.push({codigoTarifa: elemento.codigoTarifa, descrTarifa: elemento.descrTarifa,
            cicloFact: elemento.cicloFact,
            codigoServicio: elemento.codigoServicio, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
            _idSubclaseServ: elemento._idSubclaseServ, codigoSubclaseServ: elemento.codigoSubclaseServ,
            descrSubclaseServ: elemento.descrSubclaseServ, _idClaseServ: elemento._idClaseServ,
            velEfecDownstream: elemento.velEfecDownstream, velEfecUpstream: elemento.velEfecUpstream,
            codigoTipoTec: elemento.codigoTipoTec, descrTipoTec: elemento.descrTipoTec,
            colorServicio: elemento.colorServicio,
            rango1NumServValorIni: elemento.rango1NumServValorIni, rango1NumServValorFin: elemento.rango1NumServValorFin,
            rango1Valor: elemento.rango1Valor, rango2NumServValorIni: elemento.rango2NumServValorIni,
            rango2NumServValorFin: elemento.rango2NumServValorFin, rango2Valor: elemento.rango2Valor,
            rango3NumServValorIni: elemento.rango3NumServValorIni, rango3NumServValorFin: elemento.rango3NumServValorFin,
            rango3Valor: elemento.rango3Valor,
            codigoClaseServ: elemento.codigoClaseServ, descrClaseServ: elemento.descrClaseServ,
            numeroServicios: elemento.numeroServicios!==undefined?elemento.numeroServicios:'1',
            valorServicios: elemento.valorServicios!==undefined?elemento.valorServicios:valorServicios,
            valorAntesImptos: elemento.valorAntesImptos!==undefined?elemento.valorAntesImptos:valorAntesImptos,
            _id: numS, estadoSelecc: false, imptos: imptosCF});
            }
      })
      // console.log(arrayTabla2)
      arrayTabla21 = arrayTabla1.filter(item => item.estadoSelecc===false);
      arrayTabla21.forEach((elemento1, _id) => {
        arrayTabla1.forEach((elemento, _id) => {
          if(elemento.estadoSelecc===false && elemento1.codigoServicio===elemento.codigoServicio){
            const indexSearch = arrayTabla1.findIndex( servicio => servicio.codigoServicio === elemento.codigoServicio );
            arrayTabla1.splice(indexSearch, 1);
          }
        })
      })
      // console.log(arrayTabla1)
      // console.log(arrayTabla2)

      this.ordenarArrayAsc(arrayTabla1, 'descrClaseServ')
      this.ordenarArrayAsc(arrayTabla2, 'descrClaseServ')
  
      this.setState({listServTar: arrayTabla1})
      this.setState({listServ: arrayTabla2})
      this.setState({open: false})
      this.setState({errors: []})
    }

    handleTarNva = (ev, list, codigoTarifaAct, codigoTarifaNva, listTOS, cicloFact) => {
      // console.log(codigoTarifaAct)
      // console.log(codigoTarifaNva)
      // console.log(ev.target.value)
      // console.log(this.state.stlistServTarNva)
      // console.log(this.state.stListServTarAct)
      // console.log(list)
      // console.log(cicloFact)
      const listServTar = [];
      let cicloFactAct = false
      let elemento2 = []
      // console.log(listTOS[0])
      if(listTOS[0].permTarServ!=="IGUAL TARIFA - QUITAR TODOS LOS SERVICIOS"){
        if(codigoTarifaNva&&codigoTarifaNva===ev.target.value){
          // console.log(this.state.stlistServTarNva)
          elemento2.push(this.state.stlistServTarNva)
        }else{
          if(codigoTarifaAct&&codigoTarifaAct===ev.target.value){
            // console.log(this.state.stListServTarAct)
            cicloFactAct = true
            elemento2.push(this.state.stListServTarAct)
          }else{
            elemento2 = list.filter(elemento => elemento.codigoTarifa===ev.target.value)
            // console.log(elemento2)
          }
        }
      }

      // console.log(elemento2)
      const numST = elemento2.length + 1
      elemento2.forEach((elemento3, ii) => {
        elemento3.servicios.forEach((elemento, i) => {
          if(elemento.codigoServicio){
            // console.log(elemento, elemento.rango1Valor, elemento.numeroServicios, elemento.valorServicios, elemento.valorAntesImptos, elemento.imptos, codigoTarifaNva, ev.target.value, codigoTarifaAct)
            let valorServicios = 0
            let valorAntesImptos = 0
            let imptosCF = []
            if(elemento.rango1Valor){
              valorServicios = Number(elemento.rango1Valor)
              // if(valorServicios!==null&&valorServicios!==''){
              //   valorServicios = 0
              // }
              let valorI = 0
              elemento.imptos.forEach((elemento1, _id) => {
                valorI += Math.round(valorServicios * (elemento1.porcImpto / 100))
                imptosCF.push({codigoServicio: elemento.codigoServicio, _id: elemento1._id, codigoImpto: elemento1.codigoImpto,
                  descrImpto: elemento1.descrImpto, porcImpto: elemento1.porcImpto,
                  valorImpto: Math.round(valorServicios * (elemento1.porcImpto / 100))})        
              })
              valorServicios = (Math.round((valorServicios + valorI) / 10) * 10) - valorI
              valorAntesImptos = valorServicios
              valorServicios += valorI
            }else{
              imptosCF = elemento.imptos
            }
            listServTar.push({codigoTarifa: elemento3.codigoTarifa, descrTarifa: elemento3.descrTarifa,
              cicloFact: cicloFactAct?cicloFact:elemento3.cicloFact?elemento3.cicloFact:"",
              codigoServicio: elemento.codigoServicio, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
              _idSubclaseServ: elemento.subclaseserv._id, codigoSubclaseServ: elemento.subclaseserv.codigoSubclaseServ,
              descrSubclaseServ: elemento.subclaseserv.descrSubclaseServ, _idClaseServ: elemento.subclaseserv.claseserv._id,
              codigoClaseServ: elemento.subclaseserv.claseserv.codigoClaseServ, descrClaseServ: elemento.subclaseserv.claseserv.descrClaseServ,
              velEfecDownstream: elemento.velEfecDownstream, velEfecUpstream: elemento.velEfecUpstream,
              codigoTipoTec: elemento.codigoTipoTec, descrTipoTec: elemento.descrTipoTec,
              colorServicio: elemento.colorServicio,
              rango1NumServValorIni: elemento.rango1NumServValorIni, rango1NumServValorFin: elemento.rango1NumServValorFin,
              rango1Valor: elemento.rango1Valor, rango2NumServValorIni: elemento.rango2NumServValorIni,
              rango2NumServValorFin: elemento.rango2NumServValorFin, rango2Valor: elemento.rango2Valor,
              rango3NumServValorIni: elemento.rango3NumServValorIni, rango3NumServValorFin: elemento.rango3NumServValorFin,
              rango3Valor: elemento.rango3Valor,
              numeroServicios: codigoTarifaNva===ev.target.value||codigoTarifaAct===ev.target.value?elemento.numeroServicios:'1',
              valorServicios: codigoTarifaNva===ev.target.value||codigoTarifaAct===ev.target.value?elemento.valorServicios:valorServicios,
              valorAntesImptos: codigoTarifaNva===ev.target.value||codigoTarifaAct===ev.target.value?elemento.valorAntesImptos:valorAntesImptos,
              _id: i + numST, estadoSelecc: true, imptos: imptosCF
            });
          }
        })
      })
      // console.log(listServTar)
      this.ordenarArrayAsc(listServTar, 'descrClaseServ')
      this.setState({listServTar})

      elemento2 = []
      if(listTOS[0].permTarServ==="IGUAL TARIFA - QUITAR UNO O VARIOS SERVICIOS"||
        listTOS[0].permTarServ==="IGUAL TARIFA - QUITAR TODOS LOS SERVICIOS"){
        elemento2.push(this.state.stListServTarAct)
      }else{
        elemento2 = list.filter(elemento => elemento.codigoTarifa===ev.target.value)
      }
      const listServ = [];
      elemento2.forEach((elemento3, ii) => {
        elemento3.servicios.forEach((elemento, i) => {
          let siExiste = false
          listServTar.forEach((elemento1, _id) => {
            if(elemento.codigoServicio===elemento1.codigoServicio){
              siExiste = true
            }
          })
          if(siExiste===false){
            // console.log(elemento)
            let valorServicios = 0
            let valorAntesImptos = 0
            let imptosCF = []
            if(elemento.rango1Valor){
              valorServicios = Number(elemento.rango1Valor)
              // if(valorServicios!==null&&valorServicios!==''){
              //   valorServicios = 0
              // }
              let valorI = 0
              elemento.imptos.forEach((elemento1, _id) => {
                valorI += Math.round(valorServicios * (elemento1.porcImpto / 100))
                imptosCF.push({codigoServicio: elemento.codigoServicio, _id: elemento1._id, codigoImpto: elemento1.codigoImpto,
                  descrImpto: elemento1.descrImpto, porcImpto: elemento1.porcImpto,
                  valorImpto: Math.round(valorServicios * (elemento1.porcImpto / 100))})        
              })
              valorServicios = (Math.round((valorServicios + valorI) / 10) * 10) - valorI
              valorAntesImptos = valorServicios
              valorServicios += valorI
            }else{
              imptosCF = elemento.imptos
            }
            listServ.push({codigoTarifa: elemento3.codigoTarifa, descrTarifa: elemento3.descrTarifa,
              cicloFact: cicloFactAct?cicloFact:elemento3.cicloFact?elemento3.cicloFact:"",
              codigoServicio: elemento.codigoServicio, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
              _idSubclaseServ: elemento.subclaseserv._id, codigoSubclaseServ: elemento.subclaseserv.codigoSubclaseServ,
              descrSubclaseServ: elemento.subclaseserv.descrSubclaseServ, _idClaseServ: elemento.subclaseserv.claseserv._id,
              codigoClaseServ: elemento.subclaseserv.claseserv.codigoClaseServ, descrClaseServ: elemento.subclaseserv.claseserv.descrClaseServ,
              velEfecDownstream: elemento.velEfecDownstream, velEfecUpstream: elemento.velEfecUpstream,
              codigoTipoTec: elemento.codigoTipoTec, descrTipoTec: elemento.descrTipoTec,
              colorServicio: elemento.colorServicio,
              rango1NumServValorIni: elemento.rango1NumServValorIni, rango1NumServValorFin: elemento.rango1NumServValorFin,
              rango1Valor: elemento.rango1Valor, rango2NumServValorIni: elemento.rango2NumServValorIni,
              rango2NumServValorFin: elemento.rango2NumServValorFin, rango2Valor: elemento.rango2Valor,
              rango3NumServValorIni: elemento.rango3NumServValorIni, rango3NumServValorFin: elemento.rango3NumServValorFin,
              rango3Valor: elemento.rango3Valor,
              numeroServicios: codigoTarifaAct===ev.target.value?elemento.numeroServicios:'1',
              valorAntesImptos: codigoTarifaAct===ev.target.value?elemento.valorAntesImptos:valorAntesImptos,
              valorServicios: codigoTarifaAct===ev.target.value?elemento.valorServicios:valorServicios,
              _id: i, estadoSelecc: false, imptos: imptosCF});
          }
        })
      })
      // console.log(listServ)
      this.ordenarArrayAsc(listServ, 'descrClaseServ')
      this.setState({listServ})
    }

    handleOfNva = (ev, list, codigoOfertaAct, codigoOfertaNva) => {
      const numDM = getNumDiasMes(this.state.argsDocum.fechaFra.substr(5, 2), this.state.argsDocum.fechaFra.substr(0, 4))
      const numDF = numDM - parseInt(this.state.argsDocum.fechaFra.substr(8, 2), 10) + 1
      const listServOf = [];
      let elemento2 = []
//       if(codigoOfertaNva===ev.target.value){
//         console.log("1")
//         elemento2.push(this.state.stlistServOfNva)
//       }else{
//         if(codigoOfertaAct===ev.target.value){
// console.log("2")
//           elemento2.push(this.state.stListServOfAct)
//         }else{
// console.log("3")
          elemento2 = list.filter(elemento => elemento.codigoOferta===ev.target.value)
// console.log(elemento2)
          //   }
      // }
// console.log(elemento2)
      // const numST = elemento2.length + 1
      elemento2.forEach((elemento3, ii) => {
        elemento3.servicios.forEach((elemento, i) => {
          if(elemento.codigoServicio){
            // let fechaFinal = new Date(this.state.argsDocum.fechaFra)
            // fechaFinal.setDate(fechaFinal.getUTCDate() + parseInt(elemento.numDiasOferta, 10))
            // let fechaInicio = new Date(this.state.argsDocum.fechaFra).getTime();
            let fechaInicial, fechaFinal, fechaInicio, fechaFin
            if((codigoOfertaNva===ev.target.value||codigoOfertaAct===ev.target.value)&&codigoOfertaNva){
              fechaInicial = elemento.fechaInicioOferta
              fechaFinal = elemento.fechaFinOferta

              fechaInicio = new Date(elemento.fechaInicioOferta).getTime();
              fechaFin = new Date(elemento.fechaFinOferta).getTime();
            }else{
              fechaInicial = this.state.argsDocum.fechaFra
              fechaFinal = new Date(this.state.argsDocum.fechaFra)
              fechaFinal.setDate(fechaFinal.getUTCDate() + parseInt(elemento.numDiasOferta, 10))
              fechaFinal = (fechaFinal.getFullYear()) + '-' + ((fechaFinal.getMonth()+1)<10?'0'+(fechaFinal.getMonth()+1):(fechaFinal.getMonth()+1)) + '-' + (fechaFinal.getUTCDate()<10?'0'+fechaFinal.getUTCDate():fechaFinal.getUTCDate())
              
              fechaInicio = new Date(this.state.argsDocum.fechaFra).getTime();
              fechaFin = new Date(fechaFinal).getTime();
            }
            // let fechaFin    = new Date(codigoOfertaNva===ev.target.value||codigoOfertaAct===ev.target.value?elemento.fechaFinOferta:fechaFinal).getTime();
            let numdiApliOf = parseInt((fechaFin - fechaInicio) / (1000*60*60*24), 10)
            if(numdiApliOf>numDF){
              numdiApliOf = numDF
            }
            // console.log(fechaInicial)
            // console.log(fechaFinal)

            listServOf.push({codigoOferta: elemento3.codigoOferta, descrOferta: elemento3.descrOferta,
              codigoServicio: elemento.codigoServicio, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
              _idSubclaseServ: elemento.subclaseserv._id, codigoSubclaseServ: elemento.subclaseserv.codigoSubclaseServ,
              descrSubclaseServ: elemento.subclaseserv.descrSubclaseServ, _idClaseServ: elemento.subclaseserv.claseserv._id,
              codigoClaseServ: elemento.subclaseserv.claseserv.codigoClaseServ, descrClaseServ: elemento.subclaseserv.claseserv.descrClaseServ,
              porcDctoOferta: elemento.porcDctoOferta, numDiasOferta: elemento.numDiasOferta,
              fechaFinOferta: fechaFinal,
              numdiApliOf: numdiApliOf,
              fechaInicioOferta: fechaInicial,
              _id: i, estadoSelecc: true
              // _id: i + numST, estadoSelecc: true
            });
          }
        })
      })
// console.log(listServOf)
      this.ordenarArrayAsc(listServOf, 'descrClaseServ')
      this.setState({listServOf})
    }

    handleCpto = (ev) => {
      const argsDocum = this.state.argsDocum
      var miLista = document.getElementById("miListaCpto");
      argsDocum['descrOtrosPagCl'] = miLista.options[miLista.selectedIndex].text
      if(miLista.options[miLista.selectedIndex].text!=="Seleccionar..."){
        argsDocum['porcImpto'] = miLista.options[miLista.selectedIndex].attributes[0].value?miLista.options[miLista.selectedIndex].attributes[0].value:""
        argsDocum['descrImpto'] = miLista.options[miLista.selectedIndex].value?miLista.options[miLista.selectedIndex].value:""
        argsDocum['descrClaseServ'] = miLista.options[miLista.selectedIndex].attributes[1].value?miLista.options[miLista.selectedIndex].attributes[1].value:""
        argsDocum['codigoImpto'] = miLista.options[miLista.selectedIndex].attributes[2].value?miLista.options[miLista.selectedIndex].attributes[2].value:""
      }else{
        argsDocum['porcImpto'] = ""
        argsDocum['descrImpto'] = ""
        argsDocum['descrClaseServ'] = ""
        argsDocum['codigoImpto'] = ""
      }
      this.setState({argsDocum});
    }
  
    handleQuestionUpdDel = async (ev) => {
        var btnPress = await ev.target.attributes[0].value
        // if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
        if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false, confirmaAct: false})};
        if(btnPress==="No"){
            this.setState({open: false})
        };
        if(btnPress==="Si"){
            this.setState({confirmaAct: true})
            this.setState({open: false})
            const myBtn = await document.getElementById("btnUpdDel");
            myBtn.click()
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps){
      if(this.props.lisInf!==nextProps.lisInf){
        this.setState({listInf: this.props.lisInfIni})
        this.setState({listSup: this.props.lisSupIni})
      }
      if(this.props.permiteDir===nextProps.permiteDir&&this.props.permiteTar===nextProps.permiteTar&&
        this.props.permiteOfer===nextProps.permiteOfer&&this.props.permiteEqu===nextProps.permiteEqu){
        if(this.props.errors!==nextProps.errors){
          this.setState({errors: nextProps.errors})
        }
      }else{
        this.setState({errors: []})
        if(this.props.permiteTar!==nextProps.permiteTar){
          this.setState({listServTar: []})
          this.setState({listServ: []})
        }
      }
      this.setState({open: false})
    }

    shouldComponentUpdate(nextProps, nextState){
      if(this.props.lisInf!==nextProps.lisInf||this.state.listInf!==nextState.lisInf){
        return true
      }else{
        return false
      }
    }

    async componentDidUpdate(prevProps, prevState){
      if(this.state.ctrlEntr===0&&this.props.allClientes2.allClientes!==undefined){
        this.setState({ctrlEntr: 1})
        if(this.props.allClientes2.allClientes!==undefined&&((this.props.allClientes2.allClientes&&this.props.cliente.direccion.descrTipoVia1)||
        this.props.cliente.estadoCliente==="NUEVO")){
          if(this.props.allClientes2.allClientes.length===50){
          let argsBuscar={}
          if(this.props.cliente.direccion.descrTipoVia1){
            argsBuscar.descrTipoVia1=this.props.cliente.direccion.descrTipoVia1
          }else{
            argsBuscar.descrTipoVia1=null
          }
          if(this.props.cliente.direccion.numeroTipoVia1){
            argsBuscar.numeroTipoVia1=this.props.cliente.direccion.numeroTipoVia1
          }else{
            argsBuscar.numeroTipoVia1=null
          }
          if(this.props.cliente.direccion.descrTipoVia2){
            argsBuscar.descrTipoVia2=this.props.cliente.direccion.descrTipoVia2
          }else{
            argsBuscar.descrTipoVia2=null
          }
          if(this.props.cliente.direccion.numeroTipoVia2){
            argsBuscar.numeroTipoVia2=this.props.cliente.direccion.numeroTipoVia2
          }else{
            argsBuscar.numeroTipoVia2=null
          }
          if(this.props.cliente.direccion.numeroTipoVia2F){
            argsBuscar.numeroTipoVia2F=this.props.cliente.direccion.numeroTipoVia2F
          }else{
            argsBuscar.numeroTipoVia2F=null
          }

          let {data} = await this.props.allClientes2.refetch(argsBuscar)
          if(data&&this.props.cliente.estadoCliente!=="NUEVO"){
          // console.log(data)
            let numCliDir = 0
            let clienteDir = await data.allClientes
            if(clienteDir.length>0){
              let listCliDirAct = []
              clienteDir.forEach((elemento, i) => {
                // console.log(elemento.estadoCliente)
                if(elemento.contrato!==this.props.cliente.contrato&&
                    elemento.estadoCliente!=="RETIRADO"){
                  numCliDir += 1
                  if(numCliDir<6){
                    if(numCliDir>1){
                      listCliDirAct.push(", " + elemento.contrato)
                    }else{
                      listCliDirAct.push(elemento.contrato)
                    }
                  }
                }
              })
              this.setState({listCliDirAct})
              // console.log(listCliDirAct)
            }
          }
          if(this.state.StLinea1DN){
            // console.log(this.props.list7[0].direccion)
            if(this.state.StLinea1DN.descrTipoVia1){
              let argsBuscar={}
              if(this.state.StLinea1DN.descrTipoVia1){
                argsBuscar.descrTipoVia1=this.state.StLinea1DN.descrTipoVia1
              }else{
                argsBuscar.descrTipoVia1=null
              }
              if(this.state.StLinea1DN.numeroTipoVia1){
                argsBuscar.numeroTipoVia1=this.state.StLinea1DN.numeroTipoVia1
              }else{
                argsBuscar.numeroTipoVia1=null
              }
              if(this.state.StLinea1DN.descrTipoVia2){
                argsBuscar.descrTipoVia2=this.state.StLinea1DN.descrTipoVia2
              }else{
                argsBuscar.descrTipoVia2=null
              }
              if(this.state.StLinea1DN.numeroTipoVia2){
                argsBuscar.numeroTipoVia2=this.state.StLinea1DN.numeroTipoVia2
              }else{
                argsBuscar.numeroTipoVia2=null
              }
              if(this.state.StLinea1DN.numeroTipoVia2F){
                argsBuscar.numeroTipoVia2F=this.state.StLinea1DN.numeroTipoVia2F
              }else{
                argsBuscar.numeroTipoVia2F=null
              }
              let {data} = await this.props.allClientes2.refetch(argsBuscar)
              if(data){
                let numCliDir = 0
                let clienteDir = await data.allClientes
                if(clienteDir.length>0){
                  let listCliDirNva = []
                  clienteDir.forEach((elemento, i) => {
                    // console.log(elemento.estadoCliente)
                    if(elemento.contrato!==this.props.cliente.contrato&&
                          elemento.estadoCliente!=="RETIRADO"){
                      numCliDir += 1
                      if(numCliDir<6){
                        if(numCliDir>1){
                          listCliDirNva.push(", " + elemento.contrato)
                        }else{
                          listCliDirNva.push(elemento.contrato)
                        }
                      }
                    }
                  })
                  this.setState({listCliDirNva})
                }
              }
            }      
          }
        }
      }
    }
    if(this.props.list7!==prevProps.list7){
      this.setState({argsDocum: {numeroOS: this.props.list7[0].numeroOS,
                      impresa: this.props.list7[0].impresa,
                      descrTipoOS: this.props.list7[0].tipoos.descrTipoOS,
                      ptosAdic: this.props.list7[0].ptosAdic,
                      descrCategOST: this.props.list7[0].descrCategOST?this.props.list7[0].descrCategOST:"",
                      observacAB: this.props.list7[0].observacAB,
                      observacCA: "",
                      observacCE: "",
                      tipoOSDirAnt: "Seleccionar...",
                      observacABOS: "",
                      codigoMarquilla: this.props.list7[0].codigoMarquilla?this.props.list7[0].codigoMarquilla:"",
                      descrNodo: this.props.list7[0].descrNodo?this.props.list7[0].descrNodo:null,
                      codigoPaquete: this.props.list7[0].codigoPaquete?this.props.list7[0].codigoPaquete:null,
                      descrPaquete: this.props.list7[0].descrPaquete?this.props.list7[0].descrPaquete:null,
                      descrClasifOST: this.props.list7[0].descrClasifOST?this.props.list7[0].descrClasifOST:null,
                      noFactOSAb: this.props.cliente.noFactOSAb?this.props.cliente.noFactOSAb:"",
                      estadoCierre: null,
                      codigoTipoDocV: this.props.list7[0].codigoTipoDocV?this.props.list7[0].codigoTipoDocV:null,
                      numeroDocumV: this.props.list7[0].numeroDocumV?this.props.list7[0].numeroDocumV:null,
                      descrRecursoV: this.props.list7[0].descrRecursoV?this.props.list7[0].descrRecursoV:"Seleccionar...",
                      fechaEjec: this.props.list7[0].fechaEjec.substr(0, 10),
                      fechaFra: this.props.list7[0].fechaFra.substr(0, 10),
                      valorCpto1: 0,
                      valorCpto2: 0,
                      valorCpto3: 0,
                      descrOtrosPagCl: "Seleccionar...", codigoImpto: "", descrImpto: "",
                      porcImpto: "", descrClaseServ: "", stValor: 0,
                      descrEstrato: "Seleccionar...",
                      _id: this.props.list7[0]._id},
                    StLinea1DN: {descrTipoVia1: this.props.list7[0].direccion?this.props.list7[0].direccion.descrTipoVia1:"",
                      numeroTipoVia1: this.props.list7[0].direccion?this.props.list7[0].direccion.numeroTipoVia1:"",
                      descrTipoVia2: this.props.list7[0].direccion?this.props.list7[0].direccion.descrTipoVia2:"",
                      numeroTipoVia2: this.props.list7[0].direccion?this.props.list7[0].direccion.numeroTipoVia2:"",
                      numeroTipoVia2F: this.props.list7[0].direccion?this.props.list7[0].direccion.numeroTipoVia2F:"",
                      descrTipoUnd1: this.props.list7[0].direccion?this.props.list7[0].direccion.descrTipoUnd1:"",
                      numeroTipoUnd1: this.props.list7[0].direccion?this.props.list7[0].direccion.numeroTipoUnd1:"",
                      descrTipoUnd2: this.props.list7[0].direccion?this.props.list7[0].direccion.descrTipoUnd2:"",
                      numeroTipoUnd2: this.props.list7[0].direccion?this.props.list7[0].direccion.numeroTipoUnd2:""},
                    StLinea2DN: {descrTiUndMat: this.props.list7[0].direccion?this.props.list7[0].direccion.descrTiUndMat:"",
                      descrUndMat: this.props.list7[0].direccion?this.props.list7[0].direccion.descrUndMat:""},
                    StLineaDNDM: {dirMayorOS: this.props.list7[0].dirmayor?this.props.list7[0].dirmayor:""},
                    descrEstratoDN: this.props.list7[0].descrEstrato?this.props.list7[0].descrEstrato:"",
                    descrEstratoDA: this.props.cliente.descrEstrato?this.props.cliente.descrEstrato:"",
                    stlistServTarNva: this.props.list7[0].tarifa?this.props.list7[0].tarifa:{},
                    codigoTarifaNva: this.props.list7[0].tarifa?this.props.list7[0].tarifa.codigoTarifa:"",

                    stListServOfAct: this.props.cliente.oferta?this.props.cliente.oferta:{},
                    stlistServOfNva: this.props.list7[0].oferta?this.props.list7[0].oferta:{},
                    // codigoOfertaAct: this.props.cliente.oferta?this.props.cliente.oferta.codigoOferta:"",
                    codigoOfertaNva: this.props.list7[0].oferta?this.props.list7[0].oferta.codigoOferta:"",

                    stListEquiCliAct: this.props.cliente.equipos?this.props.cliente.equipos:[],
                    // stlistEquiCliNva: this.props.list7[0].equipos?this.props.list7[0].equipos:{},
                    // numeroSerieNva: this.props.list7[0].equipos?this.props.list7[0].equipos.numeroSerie:"",

                    ctrlEntr: 0,

                stlistEquiCliNva: this.props.cliente.equipos&&!this.props.list7[0].equipos
                    ?
                    this.props.cliente.equipos.map((elemento, i) => ({
                      numeroSerie: elemento.numeroSerie, mac: elemento.mac, accion: "IGUAL",
                        _idClaseEqu: elemento.claseequ._id, codigoClaseEqu: elemento.claseequ.codigoClaseEqu,
                        descrClaseEqu: elemento.claseequ.descrClaseEqu, _idMarcaEqu: elemento.marcaequ._id,
                        codigoMarcaEqu: elemento.marcaequ.codigoMarcaEqu, descrMarcaEqu: elemento.marcaequ.descrMarcaEqu,
                        _idFabriEqu: elemento.fabriequ._id, codigoFabriEqu: elemento.fabriequ.codigoFabriEqu,
                        descrFabriEqu: elemento.fabriequ.descrFabriEqu,
                        _id: i, estadoSelecc: true
                      }))                      
                    :this.props.list7[0].equipos?this.props.list7[0].equipos:[]

                  })
    }
  }

  render(){
    const {argsDocum, listInf, listSup, open, confirmaAct, listCliDirAct, listCliDirNva,
      checkNoFactOsAb, checkDiasRestoMes, StLinea1DN, StLinea2DN, StLineaDNDM, descrEstratoDN, descrEstratoDA,
      stListServTarAct, stlistServTarNva, imptosCF, codigoTarifaAct, codigoTarifaNva,
      stListServOfAct, stlistServOfNva, codigoOfertaAct, codigoOfertaNva, stListEquiCliAct, ctrlEntr,
      stlistEquiCliNva, codigoDpto, listServTar, listServ, listServOf, listEquiCli, listEqui,
      txtBtnAgrEq, stNumeroSerie, stMac, errors, checkTodo} = this.state;
    // console.log(this.props.empresa)
// console.log(this.props.list1)
// console.log(checkNoFactOsAb)
    let argsSelDpto = {...this.props.argsSelDpto}
    let list1 = []
    if(this.props.permiteDir){
      if(this.props.list1){
        let listaDir = this.props.list1 
        if(this.props.codigoDptoUA!=="Todos..."){
          listaDir = listaDir.filter(elemento => elemento.codigoDpto===this.props.codigoDptoUA)
          argsSelDpto['descrDpto'] = listaDir[0].descrDpto
          argsSelDpto['codigoDpto'] = listaDir[0].codigoDpto
          argsSelDpto['codigoDptoDANE'] = listaDir[0].codigoDptoDANE
          argsSelDpto['_id'] = listaDir[0]._id
        }
        if(this.props.codigoCiudadUA!=="Todas..."){
          let listaD = []
          listaDir.forEach((elemento, _id) => {
            if(listaD.length===0){
              elemento.ciudades.forEach((elemento1, _id) => {
                if(elemento1.codigoCiudad===this.props.codigoCiudadUA){
                  listaD.push(elemento)
                  argsSelDpto['nombreCiudad'] = elemento1.nombreCiudad
                  argsSelDpto['codigoCiudad'] = elemento1.codigoCiudad
                  argsSelDpto['codigoMunicipioDANE'] = elemento1.codigoMunicipioDANE
                  argsSelDpto['codigoPostalDANE'] = elemento1.codigoPostalDANE
                  argsSelDpto['codigoCiudadInterno'] = elemento1.codigoCiudadInterno
                  argsSelDpto['codBarrasRdo'] = elemento1.codBarrasRdo
                }
              })
            }
          })
          list1 = listaD
          let dpto = document.getElementById("miLista");
          if(dpto){
            dpto.options.selectedIndex = 0
          }
        }else{
          list1 = listaDir
          if(argsSelDpto.codigoDpto&&!argsSelDpto.codigoCiudad){
            list1.forEach((elemento, _id) => {
              if(argsSelDpto.codigoDpto===elemento.codigoDpto&&elemento.ciudades.length===1){
                argsSelDpto['nombreCiudad'] = elemento.ciudades[0].nombreCiudad
                argsSelDpto['codigoCiudad'] = elemento.ciudades[0].codigoCiudad
                argsSelDpto['codigoMunicipioDANE'] = elemento.ciudades[0].codigoMunicipioDANE
                argsSelDpto['codigoPostalDANE'] = elemento.ciudades[0].codigoPostalDANE
                argsSelDpto['codigoCiudadInterno'] = elemento.ciudades[0].codigoCiudadInterno
                argsSelDpto['codBarrasRdo'] = elemento.ciudades[0].codBarrasRdo
              }
            })
            }
        }
      }  
    }
    // console.log(argsSelDpto)
    // console.log(list1)
    let estadoCi = "Seleccionar..."
    switch(this.props.list[0].estadoCerrarOS){
      case 'ACTIVO':
        estadoCi = "ACTIVO"
        break
      case 'DESCONECTADO':
        estadoCi = "DESCONECTADO"
        break
      case 'DESCONECTADO, SUSPENDIDO o RETIRADO':
        estadoCi = argsDocum.estadoCierre
        break
      case 'ACTIVO, DESCONECTADO, SUSPENDIDO o RETIRADO':
        estadoCi = argsDocum.estadoCierre
        break
      case 'DEJAR IGUAL':
        estadoCi = this.props.cliente.estadoCliente
        break
      default:
        break
    }
    // console.log(this.props.listaOPC)

    let cptosOP = this.props.listaOPC
    cptosOP = _.orderBy(cptosOP, ['descrOtrosPagCl'], ['asc'])

    // console.log(estadoCi)

    const titulo = `O de S ${argsDocum.numeroOS} => ${this.props.cliente.contrato} ${this.props.cliente.nombreCliente} ${this.props.cliente.apellidoCliente}`
    const labelTN1 = "<< SE ASIGNARAN LOS SIGUIENTES SERVICIOS >>"
    const labelTN2 = "<< Servicios NO asignados >>"
    // const checkTodo = true

    const labelON1 = "<< APLICARA SOLO EN LOS SERVICIOS QUE TENGA LA TARIFA ASIGNADA >>"

    const labelEN1 = "<< SE ASIGNARAN LOS SIGUIENTES EQUIPOS >>"
    const labelEN2 = "<< Equipos a RETIRAR >>"

    //DIRECCION INICIAL
    let linea1DA
    let linea2DA
    let linea3DA
    let linea4DA
    if(!this.props.cliente.dirmayor){
      linea1DA = ""
      linea2DA = ""
      linea3DA = ""
      linea4DA = ""
    }else{
      if(!this.props.cliente.direccion){
        linea1DA = ""
        linea2DA = ""
      }else{
        linea1DA = `${this.props.cliente.direccion.descrTipoVia1?this.props.cliente.direccion.descrTipoVia1:""}
          ${this.props.cliente.direccion.numeroTipoVia1?this.props.cliente.direccion.numeroTipoVia1:""}
          ${this.props.cliente.direccion.descrTipoVia2?this.props.cliente.direccion.descrTipoVia2:""}
          ${this.props.cliente.direccion.numeroTipoVia2?this.props.cliente.direccion.numeroTipoVia2:""}
          ${this.props.cliente.direccion.numeroTipoVia2F?this.props.cliente.direccion.numeroTipoVia2F:""}
          ${this.props.cliente.direccion.descrTipoUnd1?this.props.cliente.direccion.descrTipoUnd1:""}
          ${this.props.cliente.direccion.numeroTipoUnd1?this.props.cliente.direccion.numeroTipoUnd1:""}
          ${this.props.cliente.direccion.descrTipoUnd2?this.props.cliente.direccion.descrTipoUnd2:""}
          ${this.props.cliente.direccion.numeroTipoUnd2?this.props.cliente.direccion.numeroTipoUnd2:""}`

        linea2DA = `${this.props.cliente.direccion.descrTiUndMat?this.props.cliente.direccion.descrTiUndMat:""}
          ${this.props.cliente.direccion.descrUndMat?this.props.cliente.direccion.descrUndMat:""}`
      }
      if(!this.props.cliente.dirmayor.codigoDpto){
        linea3DA = ""
        linea4DA = ""
      }else{
        linea3DA = `${this.props.cliente.dirmayor.descrDpto?this.props.cliente.dirmayor.descrDpto:""}
        ${this.props.cliente.dirmayor.ciudades.nombreCiudad?", " + this.props.cliente.dirmayor.ciudades.nombreCiudad:""}`
    
        linea4DA = `${this.props.cliente.dirmayor.ciudades.zonas.nombreZona?", Zona: " + this.props.cliente.dirmayor.ciudades.zonas.nombreZona:""}
        ${this.props.cliente.dirmayor.ciudades.zonas.barrios.nombreBarrio?", Barrio: " + this.props.cliente.dirmayor.ciudades.zonas.barrios.nombreBarrio:""}`
      }
    }
    //DIRECCION NUEVA
    // console.log(StLinea1DN)
    let linea1DN
    let linea2DN
    let linea3DN
    let linea4DN
    if(!StLinea1DN.descrTipoVia1){
      linea1DN = ""
      linea2DN = ""
      linea3DN = ""
      linea4DN = ""
    }else{
      linea1DN = `${StLinea1DN.descrTipoVia1?StLinea1DN.descrTipoVia1:""}
      ${StLinea1DN.numeroTipoVia1?StLinea1DN.numeroTipoVia1:""}
      ${StLinea1DN.descrTipoVia2?StLinea1DN.descrTipoVia2:""}
      ${StLinea1DN.numeroTipoVia2?StLinea1DN.numeroTipoVia2:""}
      ${StLinea1DN.numeroTipoVia2F?StLinea1DN.numeroTipoVia2F:""}
      ${StLinea1DN.descrTipoUnd1?StLinea1DN.descrTipoUnd1:""}
      ${StLinea1DN.numeroTipoUnd1?StLinea1DN.numeroTipoUnd1:""}
      ${StLinea1DN.descrTipoUnd2?StLinea1DN.descrTipoUnd2:""}
      ${StLinea1DN.numeroTipoUnd2?StLinea1DN.numeroTipoUnd2:""}`

      linea2DN = `${StLinea2DN.descrTiUndMat?StLinea2DN.descrTiUndMat:""}
      ${StLinea2DN.descrUndMat?StLinea2DN.descrUndMat:""}`

      if(StLineaDNDM.dirMayorOS.descrDpto){
        // console.log(StLineaDNDM.dirMayorOS)
        linea3DN = `${StLineaDNDM.dirMayorOS.descrDpto?StLineaDNDM.dirMayorOS.descrDpto:""}
        ${StLineaDNDM.dirMayorOS.ciudades.nombreCiudad?", " + StLineaDNDM.dirMayorOS.ciudades.nombreCiudad:""}`

        linea4DN = `${StLineaDNDM.dirMayorOS.ciudades.zonas.nombreZona?", Zona: " + StLineaDNDM.dirMayorOS.ciudades.zonas.nombreZona:""}
        ${StLineaDNDM.dirMayorOS.ciudades.zonas.barrios.nombreBarrio?", Barrio: " + StLineaDNDM.dirMayorOS.ciudades.zonas.barrios.nombreBarrio:""}`
      }
    }

//PARA CAMBIAR DIRECCION
    let descrEstratoDNN = `${this.props.argsSelDpto.descrEstrato?this.props.argsSelDpto.descrEstrato:""}`
    let linea1DNN = ""
    let linea2DNN = ""
    let linea3DNN = ""
    let linea4DNN = ""

    linea1DNN = `${this.props.argsSelDpto.descrTipoVia1?this.props.argsSelDpto.descrTipoVia1:""}
      ${this.props.argsSelDpto.numeroTipoVia1?this.props.argsSelDpto.numeroTipoVia1:""}
      ${this.props.argsSelDpto.descrTipoVia2?this.props.argsSelDpto.descrTipoVia2:""}
      ${this.props.argsSelDpto.numeroTipoVia2?this.props.argsSelDpto.numeroTipoVia2:""}
      ${this.props.argsSelDpto.numeroTipoVia2F?this.props.argsSelDpto.numeroTipoVia2F:""}
      ${this.props.argsSelDpto.descrTipoUnd1?this.props.argsSelDpto.descrTipoUnd1:""}
      ${this.props.argsSelDpto.numeroTipoUnd1?this.props.argsSelDpto.numeroTipoUnd1:""}
      ${this.props.argsSelDpto.descrTipoUnd2?this.props.argsSelDpto.descrTipoUnd2:""}
      ${this.props.argsSelDpto.numeroTipoUnd2?this.props.argsSelDpto.numeroTipoUnd2:""}`

    linea2DNN = `${this.props.argsSelDpto.descrTiUndMat?this.props.argsSelDpto.descrTiUndMat:""}
      ${this.props.argsSelDpto.descrUndMat?this.props.argsSelDpto.descrUndMat:""}`

    linea3DNN = `${this.props.argsSelDpto.descrDpto?this.props.argsSelDpto.descrDpto:""}
      ${this.props.argsSelDpto.nombreCiudad?", " + this.props.argsSelDpto.nombreCiudad:""}`
  
    linea4DNN = `${this.props.argsSelDpto.nombreZona?", Zona: " + this.props.argsSelDpto.nombreZona:""}
      ${this.props.argsSelDpto.nombreBarrio?", Barrio: " + this.props.argsSelDpto.nombreBarrio:""}`
      
//TARIFA ACTUAL
    let listServTarAct = [];
    let tarifaAct = ""
    let rentaAct = 0
//si esta DX stListServTarAct tiene los servicios que tenia pero no muestra servicios en Tarifa actual
    if(stListServTarAct.codigoTarifa&&(this.props.cliente.estadoCliente!=="DESCONECTADO"||
    this.props.cliente.estadoCliente!=="SUSPENDIDO"||this.props.cliente.estadoCliente!=="RETIRADO")){
      const elemento3 = stListServTarAct
      elemento3.servicios.forEach((elemento, i) => {
        rentaAct += elemento.valorServicios
        listServTarAct.push({codigoTarifa: elemento3.codigoTarifa, descrTarifa: elemento3.descrTarifa,
          codigoServicio: elemento.codigoServicio, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
          estadoServicio: elemento.estadoServicio, estadoCliente: this.props.cliente.estadoCliente,
          _idSubclaseServ: elemento.subclaseserv._id, codigoSubclaseServ: elemento.subclaseserv.codigoSubclaseServ,
          descrSubclaseServ: elemento.subclaseserv.descrSubclaseServ, _idClaseServ: elemento.subclaseserv.claseserv._id,
          codigoClaseServ: elemento.subclaseserv.claseserv.codigoClaseServ, descrClaseServ: elemento.subclaseserv.claseserv.descrClaseServ,
          velEfecDownstream: elemento.velEfecDownstream, velEfecUpstream: elemento.velEfecUpstream,
          codigoTipoTec: elemento.codigoTipoTec, descrTipoTec: elemento.descrTipoTec,
          colorServicio: elemento.colorServicio,
          numeroServicios: elemento.numeroServicios, valorServicios: elemento.valorServicios, imptos: elemento.imptos,
          valorAntesImptos: elemento.valorAntesImptos,
          _id: i, estadoSelecc: true
        });
      })
      tarifaAct = `${elemento3.codigoTarifa} => ${elemento3.descrTarifa} => Fecha vencimiento: ${elemento3.fechaVence} => Renta mensual actual: ${rentaAct}`

      this.ordenarArrayAsc(listServTarAct, 'descrClaseServ')
    }

    //TARIFA NUEVA
    let listServTarNva = [];
    let tarifaNva = ""
    let nuevaRenta = 0
    // console.log(stlistServTarNva)
    // console.log(this.props.list7[0].tarifa)
    if(stlistServTarNva.codigoTarifa){
      const elemento3 = stlistServTarNva
      elemento3.servicios.forEach((elemento, i) => {
        nuevaRenta += elemento.valorServicios
        listServTarNva.push({codigoTarifa: elemento3.codigoTarifa, descrTarifa: elemento3.descrTarifa,
          codigoServicio: elemento.codigoServicio, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
          _idSubclaseServ: elemento.subclaseserv._id, codigoSubclaseServ: elemento.subclaseserv.codigoSubclaseServ,
          descrSubclaseServ: elemento.subclaseserv.descrSubclaseServ, _idClaseServ: elemento.subclaseserv.claseserv._id,
          codigoClaseServ: elemento.subclaseserv.claseserv.codigoClaseServ, descrClaseServ: elemento.subclaseserv.claseserv.descrClaseServ,
          velEfecDownstream: elemento.velEfecDownstream, velEfecUpstream: elemento.velEfecUpstream,
          codigoTipoTec: elemento.codigoTipoTec, descrTipoTec: elemento.descrTipoTec,
          colorServicio: elemento.colorServicio,
          numeroServicios: elemento.numeroServicios, valorServicios: elemento.valorServicios, imptos: elemento.imptos,
          valorAntesImptos: elemento.valorAntesImptos,      
          _id: i, estadoSelecc: true
        });
      })
      tarifaNva = `${elemento3.codigoTarifa} => ${elemento3.descrTarifa} => Fecha vencimiento: ${elemento3.fechaVence} => Nueva renta mensual: $${nuevaRenta}`

      this.ordenarArrayAsc(listServTarNva, 'descrClaseServ')
    }else{
      // if(this.props.list[0].permTarServ!=="IGUAL TARIFA - QUITAR TODOS LOS SERVICIOS"){
        nuevaRenta = rentaAct
      // }
    }
// console.log("paso")
    //traer el número de días del mes
    const numDM = getNumDiasMes(argsDocum.fechaFra.substr(5, 2), argsDocum.fechaFra.substr(0, 4))
    const numDF = numDM - parseInt(argsDocum.fechaFra.substr(8, 2), 10) + 1

//OFERTA ACTUAL
    let listServOfAct = [];
    let ofertaAct = ""
// console.log(stListServOfAct)
// console.log(listServOfAct)
//si esta DX stListServOfAct tiene los servicios que tenia pero no muestra servicios en Tarifa actual
    if(stListServOfAct.codigoOferta&&(this.props.cliente.estadoCliente!=="DESCONECTADO"||
      this.props.cliente.estadoCliente!=="SUSPENDIDO"||this.props.cliente.estadoCliente!=="RETIRADO")){
      const elemento3 = stListServOfAct
// console.log(elemento3)
// console.log(stListServOfAct)
      elemento3.servicios.forEach((elemento, i) => {
        let fechaInicial, fechaFinal
        !elemento.fechaInicioOferta?fechaInicial = argsDocum.fechaFra:fechaInicial = elemento.fechaInicioOferta
        if(!elemento.fechaFinOferta){
          fechaFinal = new Date(elemento.fechaInicioOferta?elemento.fechaInicioOferta:argsDocum.fechaFra)
          fechaFinal.setDate(fechaFinal.getUTCDate() + parseInt(elemento.numDiasOferta, 10))
          fechaFinal = (fechaFinal.getFullYear()) + '-' + ((fechaFinal.getMonth()+1)<10?'0'+(fechaFinal.getMonth()+1):(fechaFinal.getMonth()+1)) + '-' + (fechaFinal.getUTCDate()<10?'0'+fechaFinal.getUTCDate():fechaFinal.getUTCDate())
        }else{
          fechaFinal = elemento.fechaFinOferta
        }

        let fechaInicio = new Date(fechaInicial).getTime();
        let fechaFin    = new Date(fechaFinal).getTime();
        let numdiApliOf = parseInt((fechaFin - fechaInicio) / (1000*60*60*24), 10)
        if(numdiApliOf>numDF){
          numdiApliOf = numDF
        }
// console.log(elemento)
// console.log(fechaInicial)
// console.log(fechaFinal)
        listServOfAct.push({codigoOferta: elemento3.codigoOferta, descrOferta: elemento3.descrOferta,
          codigoServicio: elemento.codigoServicio, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
          _idSubclaseServ: elemento.subclaseserv._id, codigoSubclaseServ: elemento.subclaseserv.codigoSubclaseServ,
          descrSubclaseServ: elemento.subclaseserv.descrSubclaseServ, _idClaseServ: elemento.subclaseserv.claseserv._id,
          codigoClaseServ: elemento.subclaseserv.claseserv.codigoClaseServ, descrClaseServ: elemento.subclaseserv.claseserv.descrClaseServ,
          porcDctoOferta: elemento.porcDctoOferta, numDiasOferta: elemento.numDiasOferta,
          fechaFinOferta: fechaFinal, numdiApliOf: numdiApliOf,
          fechaInicioOferta: fechaInicial,
          _id: i, estadoSelecc: true
        });
// console.log(listServOfAct)
      })
      ofertaAct = `${elemento3.codigoOferta} => ${elemento3.descrOferta}`
      this.ordenarArrayAsc(listServOfAct, 'descrClaseServ')
    }
    // console.log(listServOfAct)

//OFERTA NUEVA
    let listServOfNva = [];
    let ofertaNva = ""
    let elemOfNva = {}
    // console.log(stListServOfAct, stlistServOfNva, listServTarNva)
    if(stListServOfAct.codigoOferta&&!stlistServOfNva.codigoOferta&&listServTarNva.length>0){
// console.log(stListServOfAct)
//no hay oferta nueva, si oferta actual y si hay tarifa nueva => oferta nueva  es la oferta actual completa
      let elemento2 = this.props.list9.filter(elemento => elemento.codigoOferta===stListServOfAct.codigoOferta)
      elemento2.forEach((elemento3, ii) => {
        elemOfNva.codigoOferta = elemento3.codigoOferta
        elemOfNva.descrOferta = elemento3.descrOferta
        // elemOfNva.fechaInicioOferta = stListServOfAct.fechaInicioOferta
//A veces graba la fechaInicioOferta como null, por eso la siguiente linea
        elemOfNva.fechaInicioOferta = stListServOfAct.fechaInicioOferta?stListServOfAct.fechaInicioOferta:this.state.argsDocum.fechaFra
//         console.log("elemOfNva.fechaInicioOferta")
// console.log(elemOfNva.fechaInicioOferta)
if(stListServOfAct.fechaInicioOferta){
// console.log("stListServOfAct.fechaInicioOferta")
// console.log(stListServOfAct.fechaInicioOferta)
}else{
// console.log("this.state.argsDocum.fechaFra")
// console.log(this.state.argsDocum.fechaFra)
}

        let elemServ = {}
        let elemServicios = []
        elemento3.servicios.forEach((elemento, i) => {
          elemServ.codigoServicio = elemento.codigoServicio
          elemServ.nombreResumido = elemento.nombreResumido
          elemServ.descripcionServicio = elemento.descripcionServicio
          elemServ.numDiasOferta = elemento.numDiasOferta
          elemServ.porcDctoOferta = elemento.porcDctoOferta
          elemServ.subclaseserv = elemento.subclaseserv
          // let fechaFinal = new Date(stListServOfAct.fechaInicioOferta)
//A veces graba la fechaInicioOferta como null, por eso la siguiente linea
          let fechaFinal = new Date(stListServOfAct.fechaInicioOferta?stListServOfAct.fechaInicioOferta:this.state.argsDocum.fechaFra)
// console.log("fechaFinal")
// console.log(fechaFinal)
if(stListServOfAct.fechaInicioOferta){
// console.log("stListServOfAct.fechaInicioOferta")
// console.log(stListServOfAct.fechaInicioOferta)
}else{
// console.log("this.state.argsDocum.fechaFra")
// console.log(this.state.argsDocum.fechaFra)
}
          
          fechaFinal.setDate(fechaFinal.getUTCDate() + parseInt(elemento.numDiasOferta, 10))
          fechaFinal = (fechaFinal.getFullYear()) + '-' + ((fechaFinal.getMonth()+1)<10?'0'+(fechaFinal.getMonth()+1):(fechaFinal.getMonth()+1)) + '-' + (fechaFinal.getUTCDate()<10?'0'+fechaFinal.getUTCDate():fechaFinal.getUTCDate())
          elemServ.fechaFinOferta = fechaFinal
          elemServicios.push(elemServ)
          elemServ = {}
        })
        elemOfNva.servicios = elemServicios
      })
    }else{
      // console.log(stlistServOfNva)
      elemOfNva = stlistServOfNva
    }
// console.log(elemOfNva)
    if(elemOfNva.codigoOferta){
      // console.log("nueva oferta")
      // console.log(listServTarNva)
//Tiene nueva oferta
      listServTarNva.forEach((elemento, ii) => {
        elemOfNva.servicios.forEach((elemento1, i) => {
          if(elemento.codigoServicio===elemento1.codigoServicio){
//Encontrar número de días que faltan para que finalice la oferta
            let fechaInicio = new Date(argsDocum.fechaFra).getTime();
            let fechaFin    = new Date(elemento1.fechaFinOferta).getTime();
            let numdiApliOf = parseInt((fechaFin - fechaInicio) / (1000*60*60*24), 10)
            if(numdiApliOf>numDF){
              numdiApliOf = numDF
            }
// console.log(elemOfNva)
// console.log(elemento1.fechaFinOferta)
// console.log(elemOfNva.fechaInicioOferta)
// console.log("ahora fechaInicio y fechaFin ?")
// console.log(fechaInicio)
// console.log(fechaFin)
            listServOfNva.push({codigoOferta: elemOfNva.codigoOferta, descrOferta: elemOfNva.descrOferta,
              codigoServicio: elemento.codigoServicio, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
              _idSubclaseServ: elemento._idSubclaseServ, codigoSubclaseServ: elemento.codigoSubclaseServ,
              descrSubclaseServ: elemento.descrSubclaseServ, _idClaseServ: elemento._idClaseServ,
              codigoClaseServ: elemento.codigoClaseServ, descrClaseServ: elemento.descrClaseServ,
              porcDctoOferta: elemento1.porcDctoOferta, numDiasOferta: elemento1.numDiasOferta,
              fechaFinOferta: elemento1.fechaFinOferta, numdiApliOf: numdiApliOf,
              fechaInicioOferta: elemOfNva.fechaInicioOferta,      
              _id: i, estadoSelecc: true
            });
          }
        })
      })
      if(listServOfNva.length===0){
// console.log("no tiene nueva tarifa")
// console.log(listServTarAct)
// console.log(elemOfNva)
//No tiene nueva tarifa
        listServTarAct.forEach((elemento, ii) => {
          elemOfNva.servicios.forEach((elemento1, i) => {
            // console.log(elemento)
            // console.log(elemento1)
            if(elemento.codigoServicio===elemento1.codigoServicio){
              let fechaInicial, fechaFinal
              !elemOfNva.fechaInicioOferta?fechaInicial = argsDocum.fechaFra:fechaInicial = elemOfNva.fechaInicioOferta
              if(!elemento1.fechaFinOferta){
                fechaFinal = new Date(elemOfNva.fechaInicioOferta?elemOfNva.fechaInicioOferta:argsDocum.fechaFra)
                fechaFinal.setDate(fechaFinal.getUTCDate() + parseInt(elemento1.numDiasOferta, 10))
                fechaFinal = (fechaFinal.getFullYear()) + '-' + ((fechaFinal.getMonth()+1)<10?'0'+(fechaFinal.getMonth()+1):(fechaFinal.getMonth()+1)) + '-' + (fechaFinal.getUTCDate()<10?'0'+fechaFinal.getUTCDate():fechaFinal.getUTCDate())
              }else{
                fechaFinal = elemento1.fechaFinOferta
              }
              let fechaInicio = new Date(fechaInicial).getTime();
              let fechaFin    = new Date(fechaFinal).getTime();

              // let fechaInicio = new Date(argsDocum.fechaFra).getTime();
              // let fechaFin    = new Date(elemento1.fechaFinOferta).getTime();
              let numdiApliOf = parseInt((fechaFin - fechaInicio) / (1000*60*60*24), 10)
              if(numdiApliOf>numDF){
                numdiApliOf = numDF
              }
//               console.log(numdiApliOf)
// console.log(fechaInicial)
// console.log(fechaFinal)
              listServOfNva.push({codigoOferta: elemOfNva.codigoOferta, descrOferta: elemOfNva.descrOferta,
                codigoServicio: elemento.codigoServicio, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
                _idSubclaseServ: elemento._idSubclaseServ, codigoSubclaseServ: elemento.codigoSubclaseServ,
                descrSubclaseServ: elemento.descrSubclaseServ, _idClaseServ: elemento._idClaseServ,
                codigoClaseServ: elemento.codigoClaseServ, descrClaseServ: elemento.descrClaseServ,
                porcDctoOferta: elemento1.porcDctoOferta, numDiasOferta: elemento1.numDiasOferta,
                fechaFinOferta: fechaFinal, numdiApliOf: numdiApliOf,
                fechaInicioOferta: fechaInicial,      
                _id: i, estadoSelecc: true
              });
              // console.log(listServOfNva)
            }
          })
        })
      }
      ofertaNva = `${elemOfNva.codigoOferta} => ${elemOfNva.descrOferta} => Fecha inicio: ${argsDocum.fechaFra} => APLICARA EN LOS SIGUIENTES SERVICIOS:`
      this.ordenarArrayAsc(listServOfNva, 'descrClaseServ')
    }
// console.log(listServOfNva)

//EQUIPOS ASIGNADOS
let listEquiCliAct = [];
// console.log(stListEquiCliAct)
// console.log(this.props.cliente.equipos)
if(stListEquiCliAct.length>0){
  stListEquiCliAct.forEach((elemento, i) => {
    listEquiCliAct.push({numeroSerie: elemento.numeroSerie, mac: elemento.mac,
      _idClaseEqu: elemento.claseequ._id, codigoClaseEqu: elemento.claseequ.codigoClaseEqu,
      descrClaseEqu: elemento.claseequ.descrClaseEqu, _idMarcaEqu: elemento.marcaequ._id,
      codigoMarcaEqu: elemento.marcaequ.codigoMarcaEqu, descrMarcaEqu: elemento.marcaequ.descrMarcaEqu,
      _idFabriEqu: elemento.fabriequ._id, codigoFabriEqu: elemento.fabriequ.codigoFabriEqu,
      descrFabriEqu: elemento.fabriequ.descrFabriEqu,
      _id: i, estadoSelecc: true
    });
  })
  this.ordenarArrayAsc(listEquiCliAct, 'numeroSerie')
}

//NUEVA RELACION DE EQUIPOS
let listEquiCliNva = [];
// console.log(stlistEquiCliNva)
if(this.props.list[0].permEquipos!=="RETIRAR TODOS"){
  if(stlistEquiCliNva.length>0){
    stlistEquiCliNva.forEach((elemento, i) => {
      if(elemento.accion!=="RETIRAR"){
        listEquiCliNva.push({numeroSerie: elemento.numeroSerie, mac: elemento.mac,
          _idClaseEqu: elemento.claseequ._id, codigoClaseEqu: elemento.claseequ.codigoClaseEqu,
          descrClaseEqu: elemento.claseequ.descrClaseEqu, _idMarcaEqu: elemento.marcaequ._id,
          codigoMarcaEqu: elemento.marcaequ.codigoMarcaEqu, descrMarcaEqu: elemento.marcaequ.descrMarcaEqu,
          _idFabriEqu: elemento.fabriequ._id, codigoFabriEqu: elemento.fabriequ.codigoFabriEqu,
          descrFabriEqu: elemento.fabriequ.descrFabriEqu,
          _id: i, estadoSelecc: true
        });
      }
    })
  }else{
    if(stListEquiCliAct.length>0&&this.props.list7[0].estadoOS!=="CANCELADA"){
      stListEquiCliAct.forEach((elemento, i) => {
        listEquiCliNva.push({numeroSerie: elemento.numeroSerie, mac: elemento.mac,
          _idClaseEqu: elemento.claseequ._id, codigoClaseEqu: elemento.claseequ.codigoClaseEqu,
          descrClaseEqu: elemento.claseequ.descrClaseEqu, _idMarcaEqu: elemento.marcaequ._id,
          codigoMarcaEqu: elemento.marcaequ.codigoMarcaEqu, descrMarcaEqu: elemento.marcaequ.descrMarcaEqu,
          _idFabriEqu: elemento.fabriequ._id, codigoFabriEqu: elemento.fabriequ.codigoFabriEqu,
          descrFabriEqu: elemento.fabriequ.descrFabriEqu,
          _id: i, estadoSelecc: true
        });
      })
    }
  }
  this.ordenarArrayAsc(listEquiCliNva, 'numeroSerie')
}

//Equipos que se van a asignar
let listEquiCliAsig = [];
// if(listEquiCli.length>0||listEqui.length>0){
if(listEquiCli.length>0||listEqui.length===listEquiCliNva.length||this.props.list[0].permEquipos==="RETIRAR TODOS"){
  listEquiCliAsig = listEquiCli
}else{
  if(this.props.list7[0].equipos.length>0){
    this.props.list7[0].equipos.forEach((elemento, i) => {
      if(elemento.accion!=="RETIRAR"){
        listEquiCliAsig.push({numeroSerie: elemento.numeroSerie, mac: elemento.mac,
          _idClaseEqu: elemento.claseequ._id, codigoClaseEqu: elemento.claseequ.codigoClaseEqu,
          descrClaseEqu: elemento.claseequ.descrClaseEqu, _idMarcaEqu: elemento.marcaequ._id,
          codigoMarcaEqu: elemento.marcaequ.codigoMarcaEqu, descrMarcaEqu: elemento.marcaequ.descrMarcaEqu,
          _idFabriEqu: elemento.fabriequ._id, codigoFabriEqu: elemento.fabriequ.codigoFabriEqu,
          descrFabriEqu: elemento.fabriequ.descrFabriEqu,
          _id: i, estadoSelecc: true
        });
      }
    })
  }else{
    if(this.props.cliente.equipos){
      this.props.cliente.equipos.forEach((elemento, i) => {
        listEquiCliAsig.push({numeroSerie: elemento.numeroSerie, mac: elemento.mac,
          _idClaseEqu: elemento.claseequ._id, codigoClaseEqu: elemento.claseequ.codigoClaseEqu,
          descrClaseEqu: elemento.claseequ.descrClaseEqu, _idMarcaEqu: elemento.marcaequ._id,
          codigoMarcaEqu: elemento.marcaequ.codigoMarcaEqu, descrMarcaEqu: elemento.marcaequ.descrMarcaEqu,
          _idFabriEqu: elemento.fabriequ._id, codigoFabriEqu: elemento.fabriequ.codigoFabriEqu,
          descrFabriEqu: elemento.fabriequ.descrFabriEqu,
          _id: i, estadoSelecc: true
        });
      })
    }
  }
}
this.ordenarArrayAsc(listEquiCliAsig, 'numeroSerie')

//Equipos a retirar
let listEquiAsig = [];
if(listEqui.length>0){
  listEquiAsig = listEqui
}else{
  stListEquiCliAct.forEach((elemento, i) => {
    // console.log(elemento)
    // console.log(listEquiCliAsig)
    const indexSearch = listEquiCliAsig.findIndex( serial => serial.numeroSerie === elemento.numeroSerie );
    // console.log(indexSearch)
    if(indexSearch===-1){
      listEquiAsig.push({numeroSerie: elemento.numeroSerie, mac: elemento.mac,
        _idClaseEqu: elemento.claseequ._id, codigoClaseEqu: elemento.claseequ.codigoClaseEqu,
        descrClaseEqu: elemento.claseequ.descrClaseEqu, _idMarcaEqu: elemento.marcaequ._id,
        codigoMarcaEqu: elemento.marcaequ.codigoMarcaEqu, descrMarcaEqu: elemento.marcaequ.descrMarcaEqu,
        _idFabriEqu: elemento.fabriequ._id, codigoFabriEqu: elemento.fabriequ.codigoFabriEqu,
        descrFabriEqu: elemento.fabriequ.descrFabriEqu,
        _id: i, estadoSelecc: false
      });
    }
  })
}
this.ordenarArrayAsc(listEquiAsig, 'numeroSerie')
// console.log(listEquiAsig)
// console.log(listEquiCliAsig)

//CARGOS CLIENTE
    let agnoFra = argsDocum.fechaFra.substr(0, 4)
    let mesFra = argsDocum.fechaFra.substr(5, 2)
    let numDNvo = 0
    let cargarCli = 0

    let i=-1
    let numServ=0
    let valorServ=0
    let valorAntesI = 0
    let listServCargoFra = [];
    let periodoFrado
    let ddI = parseInt(argsDocum.fechaFra.substr(8, 2), 10) - 1
    let diaFra= parseInt(argsDocum.fechaFra.substr(8, 2), 10)
    let cargosTar = ""

    if(this.props.list7[0].estadoOS!=="ABIERTA"){
      let fechaFra
      this.props.list7[0].cargoFra.forEach((elemento, i) => {
        cargarCli += elemento.valorTotal
        fechaFra = elemento.fechaCargo
        if(elemento.valorTotal!==0){
          // console.log("1", elemento.valorTotal)
          listServCargoFra.push({codigoServicio: elemento.codigoServicio, nombreResumido: elemento.nombreResumido,
            descripcionServicio: elemento.descripcionServicio, descrClaseServ: elemento.descrClaseServ,
            velEfecDownstream: elemento.velEfecDownstream, velEfecUpstream: elemento.velEfecUpstream,
            codigoTipoTec: elemento.codigoTipoTec, descrTipoTec: elemento.descrTipoTec,
            colorServicio: elemento.colorServicio,
            numeroServicios: elemento.numeroServicios, valorServicios: elemento.valorTotal,
            imptos: elemento.imptos, agnoFra: elemento.agnoFra, mesFra: elemento.mesFra, fechaCargo: elemento.fechaCargo,
            periodoFrado: elemento.periodoFrado, valorAntesImptos: elemento.valorAntesImptos,
            _id: i, estadoSelecc: true
          });
        }
      })
      cargosTar = "CARGOS AL CLIENTE => Fecha: " + fechaFra + " => Total cargos al cliente: $" + cargarCli
      // console.log(cargarCli)
    }
    // console.log(listServTarNva, this.props.list[0], this.props.cliente.estadoCliente)
    if((tarifaNva||this.props.list[0].permTarServ==="IGUAL TARIFA - QUITAR TODOS LOS SERVICIOS"||
        this.props.list[0].estadoCerrarOS==="DESCONECTADO, SUSPENDIDO o RETIRADO")&&
        this.props.list7[0].estadoOS==="ABIERTA"){
      listServTarNva.forEach((elemento, _id) => {
        periodoFrado = ""
        // console.log(listServTarAct)
        // console.log(listServTarNva)
        // console.log(tarifaNva)
        // console.log(elemento.codigoTarifa)
        // console.log(elemento.codigoServicio)
        // console.log(this.props.list8)
        // console.log(elemento)
        //Si se valida tambien por tarifa
        //se deja con comentario porque mas adelante no se podria hacer la validacion porque
        //this.props.list8 (movClientes) no tiene el codigoTarifa
        // const indexCargoFra = listServTarAct.findIndex(servicio =>
        //   servicio.estadoServicio==="A" && servicio.codigoServicio === elemento.codigoServicio &&
        //   servicio.codigoTarifa===elemento.codigoTarifa);
        const indexCargoFra = listServTarAct.findIndex(servicio =>
          servicio.estadoServicio==="A" && servicio.codigoServicio === elemento.codigoServicio &&
            servicio.codigoTarifa === elemento.codigoTarifa);

        // console.log(indexCargoFra)
        if(indexCargoFra === -1||this.props.cliente.estadoCliente==="DESCONECTADO"||
            this.props.cliente.estadoCliente==="SUSPENDIDO"||this.props.cliente.estadoCliente==="RETIRADO"){
          //SERVICIOS NUEVOS
          // console.log("1 ", elemento.codigoServicio)
          i=i+1
          numDNvo = numDM - ddI
          numServ = elemento.numeroServicios
          valorServ = Math.round((elemento.valorServicios / numDM) * numDNvo)
          valorAntesI = Math.round((elemento.valorAntesImptos / numDM) * numDNvo)

          periodoFrado = argsDocum.fechaFra.substr(0, 8) + (diaFra<10?'0'+diaFra:(diaFra))
          periodoFrado += ' a ' + argsDocum.fechaFra.substr(0, 8) + numDM
        }else{
          // console.log("2 ", elemento.codigoServicio)
          //SERVICIOS QUE COINCIDEN
          numServ = elemento.numeroServicios - listServTarAct[indexCargoFra].numeroServicios
          // console.log(this.props.list8)
          //se revisa si en el mes ya fue cargado el servicio
          // console.log(this.props.list8CC)
          // console.log(elemento)
          let indexFrado = this.props.list8.findIndex(servicio => servicio.codigoServicio === elemento.codigoServicio
            &&servicio.agno===agnoFra&&servicio.mes===mesFra);
          if(indexFrado===-1){
            indexFrado = this.props.list8CC.findIndex(servicio => servicio.codigoServicio === elemento.codigoServicio
              &&servicio.agno===agnoFra&&servicio.mes===mesFra);
          }
          if(indexFrado===-1){
            //si no se ha cargado el servicio
            //se cobra los servicios que tenia hasta el dia anterior
            numDNvo = ddI
            valorServ = Math.round((listServTarAct[indexCargoFra].valorServicios / numDM) * numDNvo)
            valorAntesI = Math.round((listServTarAct[indexCargoFra].valorAntesImptos / numDM) * numDNvo)
            //y se cobra los servicios con los que queda el resto de dias del  mes
            numDNvo = numDM - ddI
            valorServ += Math.round((elemento.valorServicios / numDM) * numDNvo)
            valorAntesI += Math.round((elemento.valorAntesImptos / numDM) * numDNvo)

            periodoFrado = argsDocum.fechaFra.substr(0, 8) + '01 a ' + argsDocum.fechaFra.substr(0, 8) + numDM
          }else{
            //si ya se cargó el servicio
            //se cobra la diferencia de tarifa por cobrar del resto de dias del  mes
            numDNvo = numDM - ddI
            valorServ = elemento.valorServicios - listServTarAct[indexCargoFra].valorServicios
            valorServ = Math.round((valorServ / numDM) * numDNvo)
            valorAntesI = elemento.valorAntesImptos - listServTarAct[indexCargoFra].valorAntesImptos
            valorAntesI = Math.round((valorAntesI / numDM) * numDNvo)

            periodoFrado = argsDocum.fechaFra.substr(0, 8) + (diaFra<10?'0'+diaFra:(diaFra))
            periodoFrado += ' a ' + argsDocum.fechaFra.substr(0, 8) + numDM
          }
        }
        if(numServ!==0){
          i=i+1
          cargarCli += valorServ
          let imptosServ = elemento.imptos.map(impto => ({
            ...impto, valorImpto: Math.round(valorAntesI * impto.porcImpto / 100)}))

          if(valorServ!==0){
            //PARA CUANDO SE FACTURA UN MES ANTERIOR
            //verificar si NO tiene mov en el mes ant
            if(!this.props.tieneMCCMesAnt){
              //verificar si esta des, sus o ret, la os lo va a pasar a act
              if((this.props.cliente.estadoCliente==="DESCONECTADO"||this.props.cliente.estadoCliente==="SUSPENDIDO"||
                this.props.cliente.estadoCliente==="RETIRADO")&&this.props.list[0].estadoCerrarOS==="ACTIVO"){
              //crear mov en movcliccs con valor 0 y periodo NO FACTURAR para que no facture el mes
              //esto porque cuando pasa a act, viene dx desde hace 2 meses y no se le debe fact
                let fechaHoyMA = new Date()
                let agnoMA = (fechaHoyMA.getFullYear()).toString()
                let mesMA = (((fechaHoyMA.getMonth()+1)<10?'0'+(fechaHoyMA.getMonth()+1):(fechaHoyMA.getMonth()+1))).toString()
                mesMA = parseInt(mesMA, 10)
                if(mesMA==="01"){
                  agnoMA = (parseInt(agnoMA, 10) - 1).toString()
                  mesMA = "12"
                }else{
                  mesMA = (((mesMA-1)<10?'0'+(mesMA-1):(mesMA-1))).toString()
                }
                // let periodoFradoMA = agnoMA + "-" + mesMA + "-01 a " + agnoMA + "-" + mesMA + "-30"
                let periodoFradoMA = "NO FACTURAR"
                // let pruebaFMA =[]
                // pruebaFMA.push({codigoTarifa: elemento.codigoTarifa, descrTarifa: elemento.descrTarifa,
                // console.log("2")
                listServCargoFra.push({codigoTarifa: elemento.codigoTarifa, descrTarifa: elemento.descrTarifa,
                  codigoServicio: elemento.codigoServicio, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
                  _idSubclaseServ: elemento._idSubclaseServ, codigoSubclaseServ: elemento.codigoSubclaseServ,
                  descrSubclaseServ: elemento.descrSubclaseServ, _idClaseServ: elemento._idClaseServ,
                  codigoClaseServ: elemento.codigoClaseServ, descrClaseServ: elemento.descrClaseServ,
                  velEfecDownstream: elemento.velEfecDownstream, velEfecUpstream: elemento.velEfecUpstream,
                  codigoTipoTec: elemento.codigoTipoTec, descrTipoTec: elemento.descrTipoTec,
                  colorServicio: elemento.colorServicio,
                  numeroServicios: numServ, valorServicios: 0, imptos: [],
                  agnoFra: agnoMA, mesFra: mesMA, fechaCargo: argsDocum.fechaFra, periodoFrado: periodoFradoMA,
                  valorAntesImptos: 0,
                  _id: i, estadoSelecc: true
                });
                i=i+1
                // console.log(pruebaFMA)
                // console.log(listServCargoFra)
              }
            }
            //FIN PARA CUANDO SE FACTURA UN MES ANTERIOR

            // console.log("3", valorServ, periodoFrado)
            listServCargoFra.push({codigoTarifa: elemento.codigoTarifa, descrTarifa: elemento.descrTarifa,
              codigoServicio: elemento.codigoServicio, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
              _idSubclaseServ: elemento._idSubclaseServ, codigoSubclaseServ: elemento.codigoSubclaseServ,
              descrSubclaseServ: elemento.descrSubclaseServ, _idClaseServ: elemento._idClaseServ,
              codigoClaseServ: elemento.codigoClaseServ, descrClaseServ: elemento.descrClaseServ,
              velEfecDownstream: elemento.velEfecDownstream, velEfecUpstream: elemento.velEfecUpstream,
              codigoTipoTec: elemento.codigoTipoTec, descrTipoTec: elemento.descrTipoTec,
              colorServicio: elemento.colorServicio,
              numeroServicios: numServ, valorServicios: valorServ, imptos: imptosServ,
              agnoFra: agnoFra, mesFra: mesFra, fechaCargo: argsDocum.fechaFra, periodoFrado: periodoFrado,
              valorAntesImptos: valorAntesI,
              _id: i, estadoSelecc: true
            });
            // console.log("33", elemento.descripcionServicio, valorServ)
            // console.log(listServCargoFra)
            // console.log("33", this.props.list[0].permTarServ, elemento.codigoServicio, this.props.list8Fact)
            //Si ya facturo el mes siguiente => descontar lo facturado
            // if(this.props.list[0].permTarServ==="CAMBIAR TARIFA"||
            //     this.props.list[0].permTarServ==="IGUAL TARIFA - CAMBIAR SERVICIOS"||
            //     this.props.list[0].permTarServ==="IGUAL TARIFA - QUITAR TODOS LOS SERVICIOS"){
            // if(this.props.list[0].permTarServ==="CAMBIAR TARIFA"){
            if(this.props.list[0].permTarServ==="CAMBIAR TARIFA"||
                ((this.props.cliente.estadoCliente==="DESCONECTADO"||
                  this.props.cliente.estadoCliente==="SUSPENDIDO"||
                  this.props.cliente.estadoCliente==="RETIRADO")&&
                  this.props.list[0].estadoCerrarOS==="ACTIVO")
                ){
              let indexFrado = this.props.list8Fact.findIndex(servicio => servicio.codigoServicio === elemento.codigoServicio);
              // console.log(indexFrado)
              if(indexFrado!==-1){
                if(this.props.list8Fact[indexFrado].valorTotal!==0){
                  let imptosServ = elemento.imptos.map(impto => ({
                    ...impto, valorImpto: Math.round(this.props.list8Fact[indexFrado].valorAntesImptos * impto.porcImpto / 100)}))
                    // console.log("4", this.props.list8Fact[indexFrado].valorTotal)
                  listServCargoFra.push({codigoTarifa: elemento.codigoTarifa, descrTarifa: elemento.descrTarifa,
                    codigoServicio: elemento.codigoServicio, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
                    _idSubclaseServ: elemento._idSubclaseServ, codigoSubclaseServ: elemento.codigoSubclaseServ,
                    descrSubclaseServ: elemento.descrSubclaseServ, _idClaseServ: elemento._idClaseServ,
                    codigoClaseServ: elemento.codigoClaseServ, descrClaseServ: elemento.descrClaseServ,
                    velEfecDownstream: elemento.velEfecDownstream, velEfecUpstream: elemento.velEfecUpstream,
                    codigoTipoTec: elemento.codigoTipoTec, descrTipoTec: elemento.descrTipoTec,
                    colorServicio: elemento.colorServicio,
                    numeroServicios: elemento.numeroServicios, valorServicios: this.props.list8Fact[indexFrado].valorTotal,
                    imptos: imptosServ,
                    agnoFra: this.props.list8Fact[indexFrado].agno, mesFra: this.props.list8Fact[indexFrado].mes,
                    fechaCargo: argsDocum.fechaFra, periodoFrado: this.props.list8Fact[indexFrado].periodo,
                    valorAntesImptos: this.props.list8Fact[indexFrado].valorAntesImptos,
                    _id: i + 100, estadoSelecc: true
                  });
                  // console.log("4", elemento.descripcionServicio, this.props.list8Fact[indexFrado], this.props.list8Fact[indexFrado].valorTotal)
                  // console.log(listServCargoFra)
                }
              }
            }
          }
        }
      })
      //SERVICIOS QUE SE QUITARON
      //OJOOO SI ES RX Y SE QUITAN SERVICIOS => NO TENER EN CUENTA PARA CARGOS
      // console.log(this.props.cliente.estadoCliente)
      if(this.props.cliente.estadoCliente==="ACTIVO"){
        periodoFrado = ""
        // console.log(listServTarAct)
        listServTarAct.forEach((elemento, _id) => {
          const indexCargoFra = listServTarNva.findIndex(servicio => servicio.codigoServicio === elemento.codigoServicio &&
            servicio.codigoTarifa === elemento.codigoTarifa);

          // servicio.estadoServicio==="A" && servicio.codigoServicio === elemento.codigoServicio );
          if(indexCargoFra === -1&&elemento.codigoServicio&&elemento.estadoServicio==="A"){
            i=i+1

            let indexFrado = this.props.list8.findIndex(servicio => servicio.codigoServicio === elemento.codigoServicio
                                      &&servicio.agno===agnoFra&&servicio.mes===mesFra);
            if(indexFrado===-1){
              indexFrado = this.props.list8CC.findIndex(servicio => servicio.codigoServicio === elemento.codigoServicio
                &&servicio.agno===agnoFra&&servicio.mes===mesFra);
            }
            // console.log(indexFrado)
            // console.log(this.props.list8)
            // console.log(this.props.list8CC)
            // console.log(listServTarAct)
            if(indexFrado===-1){
              //se lo quitan y NO ha tenido movimientos en movclientes => a facturar los dias antes de dx
              // console.log("1")
              numDNvo = ddI
              valorServ = Math.round((elemento.valorServicios / numDM) * numDNvo)
              valorAntesI = Math.round((elemento.valorAntesImptos / numDM) * numDNvo)

              periodoFrado = argsDocum.fechaFra.substr(0, 8) + '01 a ' + (ddI<10?'0'+ddI:ddI)
            }else{
              // console.log("2")
              //se lo quitan y YA se lo habian facturado => descontarlo
              numDNvo = numDM - ddI
              valorServ = (Math.round((elemento.valorServicios / numDM) * numDNvo)) * -1
              valorAntesI = (Math.round((elemento.valorAntesImptos / numDM) * numDNvo)) * -1

              periodoFrado = argsDocum.fechaFra.substr(0, 8) + (diaFra<10?'0'+diaFra:(diaFra))
              periodoFrado += ' a ' + argsDocum.fechaFra.substr(0, 8) + numDM
            }
            // console.log(valorServ)
            cargarCli += valorServ
            let imptosServ = elemento.imptos.map(impto => ({
              ...impto, valorImpto: Math.round(valorAntesI * impto.porcImpto / 100)}))
            // console.log(elemento)
            // console.log(valorServ)
            if(valorServ!==0){
              // console.log("5", valorServ)
              listServCargoFra.push({codigoTarifa: elemento.codigoTarifa, descrTarifa: elemento.descrTarifa,
                codigoServicio: elemento.codigoServicio, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
                _idSubclaseServ: elemento._idSubclaseServ, codigoSubclaseServ: elemento.codigoSubclaseServ,
                descrSubclaseServ: elemento.descrSubclaseServ, _idClaseServ: elemento._idClaseServ,
                codigoClaseServ: elemento.codigoClaseServ, descrClaseServ: elemento.descrClaseServ,
                velEfecDownstream: elemento.velEfecDownstream, velEfecUpstream: elemento.velEfecUpstream,
                codigoTipoTec: elemento.codigoTipoTec, descrTipoTec: elemento.descrTipoTec,
                colorServicio: elemento.colorServicio, 
                numeroServicios: 0 - elemento.numeroServicios, valorServicios: valorServ, imptos: imptosServ,
                agnoFra: agnoFra, mesFra: mesFra, fechaCargo: argsDocum.fechaFra, periodoFrado: periodoFrado,
                valorAntesImptos: valorAntesI,
                _id: i, estadoSelecc: true
              });
              // console.log("44", elemento.descripcionServicio, valorServ, imptosServ)
              // console.log(listServCargoFra)
            }
            
            //Si ya facturo el mes siguiente => descontar lo facturado
            // console.log("33", this.props.list[0].permTarServ, elemento.codigoServicio, this.props.list8Fact)
            if(this.props.list[0].permTarServ==="CAMBIAR TARIFA"||
                this.props.list[0].permTarServ==="IGUAL TARIFA - CAMBIAR SERVICIOS"||
                this.props.list[0].permTarServ==="IGUAL TARIFA - QUITAR TODOS LOS SERVICIOS"){
              indexFrado = this.props.list8Fact.findIndex(servicio => servicio.codigoServicio === elemento.codigoServicio);
              // console.log(indexFrado)
              if(indexFrado!==-1){
                if(this.props.list8Fact[indexFrado].valorTotal!==0){
                  let imptosServ = elemento.imptos.map(impto => ({
                    ...impto, valorImpto: Math.round(this.props.list8Fact[indexFrado].valorAntesImptos * -1 * impto.porcImpto / 100)}))
                    // console.log("6", this.props.list8Fact[indexFrado].valorTotal * -1)
                  listServCargoFra.push({codigoTarifa: elemento.codigoTarifa, descrTarifa: elemento.descrTarifa,
                    codigoServicio: elemento.codigoServicio, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
                    _idSubclaseServ: elemento._idSubclaseServ, codigoSubclaseServ: elemento.codigoSubclaseServ,
                    descrSubclaseServ: elemento.descrSubclaseServ, _idClaseServ: elemento._idClaseServ,
                    codigoClaseServ: elemento.codigoClaseServ, descrClaseServ: elemento.descrClaseServ,
                    velEfecDownstream: elemento.velEfecDownstream, velEfecUpstream: elemento.velEfecUpstream,
                    codigoTipoTec: elemento.codigoTipoTec, descrTipoTec: elemento.descrTipoTec,
                    colorServicio: elemento.colorServicio,      
                    numeroServicios: 0 - elemento.numeroServicios, valorServicios: this.props.list8Fact[indexFrado].valorTotal * -1,
                    imptos: imptosServ,
                    agnoFra: this.props.list8Fact[indexFrado].agno, mesFra: this.props.list8Fact[indexFrado].mes,
                    fechaCargo: argsDocum.fechaFra, periodoFrado: this.props.list8Fact[indexFrado].periodo,
                    valorAntesImptos: this.props.list8Fact[indexFrado].valorAntesImptos * -1,
                    _id: i + 100, estadoSelecc: true
                  });
                  // console.log("6", elemento.descripcionServicio, valorServ, imptosServ)
                  // console.log(listServCargoFra)
                }
              }
            }
          }
        })
      }
    }
    // console.log(listServCargoFra)
    //APLICAR OFERTA A LOS CARGOS DEL CLIENTE
    let cargarCliOf = 0

//Se unen los servicios de oferta nueva y actual
    let lisOferta = []
    listServOfAct.forEach((elemento, i) => {
      lisOferta.push(elemento)
    })
    let ii = lisOferta.length + 1
    listServOfNva.forEach((elemento, i) => {
      // console.log(elemento)
      const indexLis = lisOferta.findIndex(codServ => codServ.codigoServicio === elemento.codigoServicio);
      if(indexLis===-1){
// console.log(elemento.fechaInicioOferta)
// console.log(elemento.fechaFinOferta)
        lisOferta.push({codigoOferta: elemento.codigoOferta, descrOferta: elemento.descrOferta,
          codigoServicio: elemento.codigoServicio, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
          _idSubclaseServ: elemento._idSubclaseServ, codigoSubclaseServ: elemento.codigoSubclaseServ,
          descrSubclaseServ: elemento.descrSubclaseServ, _idClaseServ: elemento._idClaseServ,
          codigoClaseServ: elemento.codigoClaseServ, descrClaseServ: elemento.descrClaseServ,
          porcDctoOferta: elemento.porcDctoOferta, numDiasOferta: elemento.numDiasOferta,
          fechaFinOferta: elemento.fechaFinOferta, numdiApliOf: elemento.numdiApliOf,
          fechaInicioOferta: elemento.fechaInicioOferta,      
          _id: ii + i, estadoSelecc: true
        });
      }
    })

    // console.log(lisOferta)
    // console.log(listServOfNva)
    // console.log(listServOfAct)

    if(this.props.list7[0].estadoOS==="ABIERTA"){
      // console.log(listServCargoFra)
      const elemCF = listServCargoFra.map((elemento, _id) => elemento);
      elemCF.forEach((elemento, ii) => {
        lisOferta.forEach((elemento1, i) => {
          // console.log("22")
          // if(elemento.codigoServicio===elemento1.codigoServicio&&elemento.valorServicios>0){
          if(elemento.codigoServicio===elemento1.codigoServicio){
            // console.log(elemento.codigoServicio)
            let valorDcto = 0
            let valorDctoAI = 0
            if(numDF===elemento1.numdiApliOf){
              valorDcto = elemento.valorServicios - (elemento.valorServicios * elemento1.porcDctoOferta / 100)
              valorDctoAI = elemento.valorAntesImptos - (elemento.valorAntesImptos * elemento1.porcDctoOferta / 100)
            }else{
              valorDcto = (elemento.valorServicios - (elemento.valorServicios * elemento1.porcDctoOferta / 100)) / numDF
              valorDcto = valorDcto * elemento1.numdiApliOf
              valorDctoAI = (elemento.valorAntesImptos - (elemento.valorAntesImptos * elemento1.porcDctoOferta / 100)) / numDF
              valorDctoAI = valorDctoAI * elemento1.numdiApliOf
            }
            const indexLis = listServCargoFra.findIndex(codServ => codServ.codigoServicio === elemento.codigoServicio);
            valorDcto = parseInt(valorDcto, 10)
            valorDctoAI = parseInt(valorDctoAI, 10)
            if(valorDcto!==0){
              cargarCliOf += valorDcto
              listServCargoFra[indexLis].valorServicios = valorDcto
              listServCargoFra[indexLis].valorAntesImptos = valorDctoAI

              //Actualizar imptos con la oferta
              listServCargoFra[indexLis].imptos.forEach((elemento2, i) => {
                elemento2.valorImpto = Math.round(valorDctoAI * elemento2.porcImpto / 100)
              })
            }else{
              if(indexLis!==-1){
                cargarCli += 0 - listServCargoFra[indexLis].valorServicios
                listServCargoFra.splice(indexLis, 1);
              }
            }
          }
        })
      })
      // console.log(this.props.list8)
      // console.log(stListServOfAct)
      // console.log(stlistServOfNva)
      // console.log(listServOfNva)
      if(((elemCF.length===0&&listServOfNva.length>0&&stlistServOfNva.codigoOferta)||
        (stListServOfAct.codigoOferta&&stlistServOfNva.codigoOferta))
        &&stListServOfAct.codigoOferta!==stlistServOfNva.codigoOferta){
        //CAMBIA LA OFERTA
        // console.log("cambia oferta")
        // console.log(stListServOfAct.codigoOferta)
        // console.log(stlistServOfNva.codigoOferta)
        listServOfNva.forEach((elemento, i) => {
          let indexFrado = this.props.list8.findIndex(servicio => servicio.codigoServicio === elemento.codigoServicio
            &&servicio.agno===agnoFra&&servicio.mes===mesFra);
          if(indexFrado===-1){
            indexFrado = this.props.list8CC.findIndex(servicio => servicio.codigoServicio === elemento.codigoServicio
              &&servicio.agno===agnoFra&&servicio.mes===mesFra);
          }
          if(indexFrado!==-1){
            //Si el servicio esta facturado, si crea el cargo de descuento, si no en la fact hace el descuento

            const indexLis = listServTarAct.findIndex(codServ =>
              codServ.estadoServicio==="A" && codServ.codigoServicio === elemento.codigoServicio);
            if(indexLis!==-1){
              //servicio de la oferta nueva esta en la tarifa actual
              // console.log(elemento)
              // console.log(listServTarAct[indexLis])
              numDNvo = numDM - ddI

              valorServ = (Math.round((listServTarAct[indexLis].valorServicios / numDM) * numDNvo))
              valorAntesI = (Math.round((listServTarAct[indexLis].valorAntesImptos / numDM) * numDNvo))

              if(numDF===elemento.numdiApliOf){
                valorServ = (valorServ * elemento.porcDctoOferta / 100)
                valorAntesI = (valorAntesI * elemento.porcDctoOferta / 100)
              }else{
                valorServ = ((valorServ * elemento.porcDctoOferta / 100)) / numDF
                valorServ = valorServ * elemento.numdiApliOf
                valorAntesI = ((valorAntesI * elemento.porcDctoOferta / 100)) / numDF
                valorAntesI = valorAntesI * elemento.numdiApliOf
              }
              // console.log(valorServ)

              valorServ = parseInt(valorServ, 10) * -1
              valorAntesI = parseInt(valorAntesI, 10) * -1
              cargarCliOf += valorServ
              // console.log(cargarCliOf)

              periodoFrado = argsDocum.fechaFra.substr(0, 8) + (diaFra<10?'0'+diaFra:(diaFra))
              periodoFrado += ' a ' + argsDocum.fechaFra.substr(0, 8) + numDM
              // console.log(periodoFrado)
              let imptosServ = listServTarAct[indexLis].imptos.map(impto => ({
                ...impto, valorImpto: Math.round(valorAntesI * impto.porcImpto / 100)}))
              // console.log(listServTarAct[indexLis])
              // console.log(valorServ)
              // let numS = new Date().getTime();
              // numS = numS + i + 1
              let numS = 327
              numS = numS + i + 1
              if(valorServ!==0){
                // console.log("7", valorServ)
                listServCargoFra.push({codigoTarifa: listServTarAct[indexLis].codigoTarifa, descrTarifa: listServTarAct[indexLis].descrTarifa,
                  codigoServicio: elemento.codigoServicio, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
                  _idSubclaseServ: listServTarAct[indexLis]._idSubclaseServ, codigoSubclaseServ: listServTarAct[indexLis].codigoSubclaseServ,
                  descrSubclaseServ: listServTarAct[indexLis].descrSubclaseServ, _idClaseServ: listServTarAct[indexLis]._idClaseServ,
                  codigoClaseServ: listServTarAct[indexLis].codigoClaseServ, descrClaseServ: listServTarAct[indexLis].descrClaseServ,
                  velEfecDownstream: elemento.velEfecDownstream, velEfecUpstream: elemento.velEfecUpstream,
                  codigoTipoTec: elemento.codigoTipoTec, descrTipoTec: elemento.descrTipoTec,  
                  colorServicio: elemento.colorServicio,    
                  numeroServicios: 0 - listServTarAct[indexLis].numeroServicios, valorServicios: valorServ, imptos: imptosServ,
                  agnoFra: agnoFra, mesFra: mesFra, fechaCargo: argsDocum.fechaFra, periodoFrado: periodoFrado,
                  valorAntesImptos: valorAntesI,
                  _id: numS, estadoSelecc: true
                });
                // console.log({...listServCargoFra})
              }
            }
          }
        })
        if(stListServOfAct.codigoOferta&&stlistServOfNva.codigoOferta
          &&stListServOfAct.codigoOferta!==stlistServOfNva.codigoOferta){
            //cambió la oferta => crear cargos fra por servicios que quedan y estan en oferta actual
          listServTarAct.forEach((elemento, i) => {
            let indexFrado = this.props.list8.findIndex(servicio => servicio.codigoServicio === elemento.codigoServicio
              &&servicio.agno===agnoFra&&servicio.mes===mesFra);
            if(indexFrado===-1){
              indexFrado = this.props.list8CC.findIndex(servicio => servicio.codigoServicio === elemento.codigoServicio
                &&servicio.agno===agnoFra&&servicio.mes===mesFra);
            }
            if(indexFrado!==-1){
              //Si el servicio esta facturado, si crea el cargo de descuento, si no en la fact hace el descuento

              //si no hay tarifa nueva => la tarifa actual
              let indexLis
              if(listServTarNva.length===0){
                indexLis = listServTarAct.findIndex(codServ => codServ.codigoServicio === elemento.codigoServicio);
              }else{
                indexLis = listServTarNva.findIndex(codServ => codServ.codigoServicio === elemento.codigoServicio);
              }
            if(indexLis!==-1){
              const indexLis = listServOfAct.findIndex(codServ => codServ.codigoServicio === elemento.codigoServicio);
              if(indexLis!==-1){
                //servicio de la tarifa actual esta en la oferta actual y en la tarifa nueva
                // console.log(elemento)
                // console.log(lisOferta)
                // console.log(listServOfAct)
                // console.log(listServOfNva)

                numDNvo = numDM - ddI

                valorServ = (Math.round((elemento.valorServicios / numDM) * numDNvo))
                valorAntesI = (Math.round((elemento.valorAntesImptos / numDM) * numDNvo))
                // console.log(valorServ)
                if(numDF===listServOfAct[indexLis].numdiApliOf){
                  valorServ = (valorServ * listServOfAct[indexLis].porcDctoOferta / 100)
                  valorAntesI = (valorAntesI * listServOfAct[indexLis].porcDctoOferta / 100)
                }else{
                  // console.log("2")
                  valorServ = ((valorServ * listServOfAct[indexLis].porcDctoOferta / 100)) / numDF
                  valorServ = valorServ * listServOfAct[indexLis].numdiApliOf
                  valorAntesI = ((valorAntesI * listServOfAct[indexLis].porcDctoOferta / 100)) / numDF
                  valorAntesI = valorAntesI * listServOfAct[indexLis].numdiApliOf
                }
                // console.log(valorServ)

                valorServ = parseInt(valorServ, 10)
                valorAntesI = parseInt(valorAntesI, 10)
                // console.log(cargarCliOf)
                cargarCliOf += valorServ
                periodoFrado = argsDocum.fechaFra.substr(0, 8) + (diaFra<10?'0'+diaFra:(diaFra))
                periodoFrado += ' a ' + argsDocum.fechaFra.substr(0, 8) + numDM
                // console.log(periodoFrado)
                let imptosServ = elemento.imptos.map(impto => ({
                  ...impto, valorImpto: Math.round(valorAntesI * impto.porcImpto / 100)}))
                // console.log(elemento)
                // console.log(valorServ)
                let numS = new Date().getTime();
                numS = numS + i + 1
                if(valorServ!==0){
                  // console.log("8", valorServ)
                  listServCargoFra.push({codigoTarifa: elemento.codigoTarifa, descrTarifa: elemento.descrTarifa,
                    codigoServicio: listServOfAct[indexLis].codigoServicio, nombreResumido: listServOfAct[indexLis].nombreResumido, descripcionServicio: listServOfAct[indexLis].descripcionServicio,
                    _idSubclaseServ: elemento._idSubclaseServ, codigoSubclaseServ:elemento.codigoSubclaseServ,
                    descrSubclaseServ: elemento.descrSubclaseServ, _idClaseServ: elemento._idClaseServ,
                    codigoClaseServ: elemento.codigoClaseServ, descrClaseServ: elemento.descrClaseServ,
                    numeroServicios: elemento.numeroServicios, valorServicios: valorServ, imptos: imptosServ,
                    agnoFra: agnoFra, mesFra: mesFra, fechaCargo: argsDocum.fechaFra, periodoFrado: periodoFrado,
                    valorAntesImptos: valorAntesI,
                    _id: numS, estadoSelecc: true
                  });
                  // console.log(listServCargoFra)
                }
              }
            }
          }
          })
        }
      }

      // console.log(listServCargoFra)
      // console.log(elemCF)
      // console.log(cargarCli)
      // console.log(cargarCliOf)
      if(cargarCliOf!==0){
        cargarCli = cargarCliOf
      }

      if(this.props.cliente.estadoCliente==="NUEVO"&&checkDiasRestoMes){
        cargarCli = 0
      }
      
      cargosTar = "CARGOS AL CLIENTE => Fecha: " + argsDocum.fechaFra + " => Total cargos al cliente: $" + cargarCli
      // console.log(cargarCli)
    }
    //FINALIZA CARGOS FACTURA

    //Se envia para el cierre solo la oferta nueva
    lisOferta = listServOfNva

//CARGOS O DE S
    // console.log(this.props.list6)
    let codTarCli = "SIN TARIFA"
    if(codigoTarifaNva){
      codTarCli = codigoTarifaNva
    }else{
      if(codigoTarifaAct){
        codTarCli = codigoTarifaAct
      }
    }
    // console.log(codTarCli)
    // console.log(this.props.list6)
    const tarCliente = this.props.list6.filter(tarifa => tarifa.codigoTarifa===codTarCli);
    let concepto1 = "", concepto2 = "", concepto3 = ""
    let valorCpto1 = 0, valorCpto2 = 0, valorCpto3 = 0
    let permCpto1 = false, permCpto2 = false, permCpto3 = false
    if(tarCliente.length===1){
      if(tarCliente[0].tipoos.length>0){
        // console.log(tarCliente[0].tipoos)
        const cptosTipoOS = tarCliente[0].tipoos.filter(cpto => cpto.codigoTipoOS===this.props.list7[0].tipoos.codigoTipoOS);
        if(cptosTipoOS.length===1){
          let valorI1 = 0, valorI2 = 0, valorI3 = 0
          let periodoFrado = agnoFra + '-' + mesFra
          let numS = new Date().getTime();
//concepto1
          if(cptosTipoOS[0].concepto1Tarifa){
            concepto1 = cptosTipoOS[0].concepto1Tarifa
            if(argsDocum.valorCpto1){
              valorCpto1 = parseInt(argsDocum.valorCpto1, 10)
            }else{
              valorCpto1 = parseInt(cptosTipoOS[0].valor1Tarifa, 10)
            }
            if(cptosTipoOS[0].valor1Tarifa==0){
              permCpto1 = true
            }
            let imptos = cptosTipoOS[0].imptos.map(impto => ({
              ...impto, valorImpto: impto.codigoImpto?Math.round(valorCpto1 * (impto.porcImpto / 100)):null}))
            imptos.forEach((elemento1, _id) => {
              valorI1 += Math.round(valorCpto1 * (elemento1.porcImpto / 100))
            })
            let valTotCpto1 = valorCpto1 + valorI1
            numS = numS + 1
            if(valorCpto1>0){
              // console.log("9", valTotCpto1)
              listServCargoFra.push({codigoServicio: "CPTO1", nombreResumido: concepto1,
                descripcionServicio: concepto1, descrClaseServ: concepto1,
                numeroServicios: 1, valorServicios: valTotCpto1,
                imptos: imptos, agnoFra: agnoFra, mesFra: mesFra, fechaCargo: argsDocum.fechaFra,
                periodoFrado: periodoFrado, valorAntesImptos: valorCpto1,
                _id: numS, estadoSelecc: true
              });
            }
          }
//concepto2
          if(cptosTipoOS[0].concepto2Tarifa){
            concepto2 = cptosTipoOS[0].concepto2Tarifa
            if(argsDocum.valorCpto2){
              valorCpto2 = parseInt(argsDocum.valorCpto2, 10)
            }else{
              valorCpto2 = parseInt(cptosTipoOS[0].valor2Tarifa, 10)
            }
            if(cptosTipoOS[0].valor2Tarifa==0){
              permCpto2 = true
            }
            let imptos = cptosTipoOS[0].imptos.map(impto => ({
              ...impto, valorImpto: impto.codigoImpto?Math.round(valorCpto2 * (impto.porcImpto / 100)):null}))
            imptos.forEach((elemento1, _id) => {
              valorI2 += Math.round(valorCpto2 * (elemento1.porcImpto / 100))
            })
            let valTotCpto2 = valorCpto2 + valorI2
            numS = numS + 1
            if(valorCpto2>0){
              // console.log("10", valTotCpto2)
              listServCargoFra.push({codigoServicio: "CPTO2", nombreResumido: concepto2,
                descripcionServicio: concepto2, descrClaseServ: concepto2,
                numeroServicios: 1, valorServicios: valTotCpto2,
                imptos: imptos, agnoFra: agnoFra, mesFra: mesFra, fechaCargo: argsDocum.fechaFra,
                periodoFrado: periodoFrado, valorAntesImptos: valorCpto2,
                _id: numS, estadoSelecc: true
              });
            }
          }
          //concepto3
          if(cptosTipoOS[0].concepto3Tarifa){
            concepto3 = cptosTipoOS[0].concepto3Tarifa
            if(argsDocum.valorCpto3){
              valorCpto3 = parseInt(argsDocum.valorCpto3, 10)
            }else{
              valorCpto3 = parseInt(cptosTipoOS[0].valor3Tarifa, 10)
            }
            if(cptosTipoOS[0].valor3Tarifa==0){
              permCpto3 = true
            }
            let imptos = cptosTipoOS[0].imptos.map(impto => ({
              ...impto, valorImpto: impto.codigoImpto?Math.round(valorCpto3 * (impto.porcImpto / 100)):null}))
            imptos.forEach((elemento1, _id) => {
              valorI3 += Math.round(valorCpto3 * (elemento1.porcImpto / 100))
            })
            let valTotCpto3 = valorCpto3 + valorI3
            numS = numS + 1
            if(valorCpto3>0){
              // console.log("11", valorCpto3)
              listServCargoFra.push({codigoServicio: "CPTO3", nombreResumido: concepto3,
                descripcionServicio: concepto3, descrClaseServ: concepto3,
                numeroServicios: 1, valorServicios: valTotCpto3,
                imptos: imptos, agnoFra: agnoFra, mesFra: mesFra, fechaCargo: argsDocum.fechaFra,
                periodoFrado: periodoFrado, valorAntesImptos: valorCpto3,
                _id: numS, estadoSelecc: true
              });
            }
          }
        }
      }
    }
    // console.log(listServCargoFra)
    let fechaHoyMA = new Date()
    fechaHoyMA = (fechaHoyMA.getFullYear()) + '-' + ((fechaHoyMA.getMonth()+1)<10?'0'+(fechaHoyMA.getMonth()+1):(fechaHoyMA.getMonth()+1)) + '-' + (fechaHoyMA.getUTCDate()<10?'0'+fechaHoyMA.getUTCDate():fechaHoyMA.getUTCDate())
    // console.log(this.props.permiteUpdate)
    let fechaV
    if(this.props.permiteUpdate){
      fechaV = document.getElementById("fechaEjec")
      fechaV = fechaV.value
    }else{
      fechaV = this.props.fechaV
    }

    let fechaF = document.getElementById("fechaFra")
    fechaF?fechaF = fechaF.value:fechaF = fechaHoyMA

    let fechaMin = argsDocum.fechaFra.substr(0, 7) + '-01'
    let fechaMax = fechaHoyMA.substr(0, 7) + '-' + numDM
    // console.log(fechaMin, fechaMax)

    // console.log(fechaF)
    // if(!concepto1){
    //   console.log("no cpto1")
    // }
    // console.log(concepto1)
    // console.log(valorCpto1)

    // console.log(permCpto1)
    // console.log(concepto2)
    // console.log(valorCpto2)
    // console.log(concepto3)
    // console.log(valorCpto3)
//FIN CARGOS O DE S

    // console.log(listServOfNva)
// console.log(this.props.errors)
// console.log(errors)
    // console.log(this.props.list7[0])
    // let listaTum = []
    // if(this.props.list){listaTum = this.props.list}
// console.log(this.props.argsSelDpto)
    // console.log(this.props.list8)
    // console.log(this.props.list8CC)
    // console.log(this.props.list7[0])
    // console.log(argsDocum)
    // console.log(this.props)
    // console.log(this.state)

    // console.log(this.props.cliente)
    // console.log(listSup)

    // console.log(listServTar)
    // console.log(this.props.list)
    // console.log(this.props.fechaV)
    // console.log(nuevaRenta)

//Si es cliente NUEVO y tiene marcado No cobrar resto de dias del mes => se ponen los cargos en cero
    if(this.props.cliente.estadoCliente==="NUEVO"&&checkDiasRestoMes){
      listServCargoFra.forEach((elemento, i) => {
        listServCargoFra[i].valorServicios=0
        listServCargoFra[i].valorAntesImptos=0
      })
    }
// console.log(checkDiasRestoMes)
    const listServCargoFraVer = listServCargoFra.filter(item => item.valorServicios!==0);
    // console.log(listServCargoFra)
    // console.log({...listServCargoFraVer})
    // this.props.permiteClose
    let mensaje = ""
    if(this.props.permiteClose){
      if(listCliDirNva.length>0){
        mensaje = "En la dirección nueva existen los contratos " + listCliDirNva + ". Esta usted seguro de cerrar la OS ?"
      }
    }
    // let mensaje = "Generar cargos especiales para el mes " + mesMsg

    let listClOS = []
    if(this.props.allClasifOST.allClasifOST){
      listClOS = this.props.allClasifOST.allClasifOST
    }
    let listNodo = []
    if(this.props.allNodo.allNodo){
      listNodo = this.props.allNodo.allNodo
    }
    let listPaq = []
    if(this.props.allPaquete.allPaquete){
      listPaq = this.props.allPaquete.allPaquete
    }
    // console.log(this.props.list)
    let listTOSDA = []
    if(this.props.list7[0].genOSDirAnt==="SI"){
      // listTOSDA = [{descrTipoOS: "Seleccionar..."}, {descrTipoOS: this.props.list[0].tipoOSDirAnt}]
      listTOSDA = [{_id: 1, tipoOSDirAnt: this.props.list[0].tipoOSDirAnt}]
    }

    let lista1 = this.props.list1Cat.filter(elemento => elemento.descrTipoOS===argsDocum.descrTipoOS)

    let updnoFactOSAb = false
    if((this.props.cliente.estadoCliente==='ACTIVO'&&(this.props.list[0].estadoCerrarOS==='DESCONECTADO, SUSPENDIDO o RETIRADO'||this.props.list[0].estadoCerrarOS==='DESCONECTADO'))){
      updnoFactOSAb = true
    }

    let list3Estr = []
    if(this.props.list3Estr){
      list3Estr = this.props.list3Estr
    }
    // console.log(this.props.list3Estr)
    // console.log(this.props.cliente.noFactOSAb)
    // console.log(checkNoFactOsAb, updnoFactOSAb)
// console.log(this.props.permiteUpdate, this.props.permiteDir, this.props.permiteTar, this.props.permiteEqu)
// console.log(this.props.list[0].permOfertas, this.props.list7[0].estadoOS)
// this.props.permiteUpdate&&!this.props.permiteDir&&!this.props.permiteTar&&
//                     !this.props.permiteOfer&&!this.props.permiteEqu&&cargarCli
// console.log(this.props.permiteUpdate, this.props.permiteDir, this.props.permiteTar)
// console.log(this.props.permiteOfer, this.props.permiteEqu, cargarCli)
// console.log(listServTar)
    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
        <i className="large hand point down yellow icon"></i>
            {titulo}
        </button>
        {this.props.permiteUpdate &&
          <div>
            <button name="btnRefr" id="btnRefr"  className='ui right labeled icon button' style={this.props.styles.titBuscar} onClick={this.handleRefresh}>
                <i className='large redo yellow icon'></i>
                Refrescar
            </button>
            <button name="btnVrInic" id="btnVrInic" className='ui right labeled icon button' style={this.props.styles.titBuscar} onClick={this.props.handleVrinic}>
                <i className='large refresh yellow icon'></i>
                Valores iniciales
            </button>
          </div>
        }

        <div style={this.props.styles.box}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.props.handleSubmit(ev, argsDocum,
                    this.props.cliente, listSup, listServTar, listServOf, listEquiCliAsig, listEquiAsig,
                    lisOferta, this.props.list, fechaV, listServCargoFra, nuevaRenta,
                    this.props.argsBod, estadoCi, fechaF, "", checkNoFactOsAb, updnoFactOSAb):()=>{}}>
            <div className="ui one column stackable grid">
              <div className="row container">
                <div className="column" width="100%">
                  {/* {
                    errors.length?<Message negative header="Los siguientes errores:"
                    list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                  } */}

{/* DATOS DE LA O DE S */}
                  {listCliDirAct.length>0 &&
                    <div>
                      <label style={{background: "#EEF24A", color: '#AD0A16', fontSize: '1.5em'}}>
                        &nbsp;&nbsp;!! Contratos de otros clientes en la dirección actual: {listCliDirAct} !!&nbsp;&nbsp;</label>
                      <Divider inverted />
                    </div>
                  }
                  {listCliDirNva.length>0 &&
                    <div>
                      <label style={{background: "#EEF24A", color: '#AD0A16', fontSize: '1.5em'}}>
                        &nbsp;&nbsp;!! Contratos de otros clientes en la dirección nueva: {listCliDirNva} !!&nbsp;&nbsp;</label>
                      <hr></hr>
                    </div>
                  }

                  {/* <Form.Field>
                    <label style={this.props.styles.label}>Tipo</label>
                    <input style={this.props.styles.input} autoComplete="off" name="descrTipoOS" id="descrTipoOS" value={this.props.permiteUpdate?argsDocum.descrTipoOS:this.props.list7[0].tipoos.descrTipoOS} onChange={this.handleChange} placeholder='Tipo' icon={!errors.length?null: _find(errors, {path:'descrTipoOS'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field> */}
                  <Form.Field>
                    <div className="ui two column stackable grid">
                      <div className="row container">
                        <div className="column" style={this.props.styles.boxGrid}>
                          <label style={this.props.styles.label}>Tipo</label>
                          <input style={this.props.styles.input} autoComplete="off" name="descrTipoOS" id="descrTipoOS" value={this.props.permiteUpdate?argsDocum.descrTipoOS:this.props.list7[0].tipoos.descrTipoOS} onChange={this.handleChange} placeholder='Tipo' icon={!errors.length?null: _find(errors, {path:'descrTipoOS'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                        </div>

                        {lista1.length>0 &&
                          <div className="column" style={this.props.styles.boxGrid}>
                            <label style={this.props.styles.label}>Categoría</label>
                            <ListaCateg list={lista1} styles={this.props.styles} idLista={this.props.list7[0]} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                          </div>
                        }
                      </div>
                    </div>
                  </Form.Field>

                  {this.props.list[0].pedirPtosAdic==="SI" &&
                    <Form.Field>
                      <label style={this.props.styles.label}>Puntos Adicionales</label>
                      <input type='number' step="1" min="0" style={this.props.styles.input} autoComplete="off" name="ptosAdic" id="ptosAdic" value={this.props.permiteUpdate?argsDocum.ptosAdic:this.props.list7[0].ptosAdic} onChange={this.handleChange} placeholder='Puntos Adicionales' icon={!errors.length?null: _find(errors, {path:'ptosAdic'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                    </Form.Field>
                  }

                  <Form.Field>
                    <label style={this.props.styles.label}>Observaciones</label>
                    <input style={this.props.styles.input} autoComplete="off" name="observacAB" id="observacAB" value={this.props.permiteUpdate?argsDocum.observacAB:this.props.list7[0].observacAB} onChange={this.handleChange} placeholder='Observaciones' icon={!errors.length?null: _find(errors, {path:'observacAB'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                  <Form.Field>
                    <div className="ui two column stackable grid">
                      <div className="row container">
                        <div className="column" style={this.props.styles.boxGrid}>
                          <label style={this.props.styles.label}>Fecha de ejecución</label>
                          <input style={this.props.styles.input} type='date' name="fechaEjec" id="fechaEjec" value={this.props.permiteUpdate?argsDocum.fechaEjec:this.props.list7[0].fechaEjec.substr(0, 10)} onChange={this.handleChange}/>
                        </div>
                        <div className="column" style={this.props.styles.boxGrid}>
                          <label style={this.props.styles.label}>Fecha inicio cargos / ofertas al cliente</label>
                          <input style={this.props.styles.input} type='date' name="fechaFra" id="fechaFra" 
                              value={this.props.permiteUpdate?argsDocum.fechaFra:this.props.list7[0].fechaFra.substr(0, 10)} 
                              min={fechaMin} max={fechaMax} onChange={this.handleChange}/>
                          {this.props.cliente.estadoCliente==="NUEVO" &&
                            <p style={this.props.styles.label}>
                              <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' name="checkDiasRestoMes" checked={checkDiasRestoMes}  onChange={this.handleChange}/>
                              &nbsp;&nbsp;No cobrar resto de días del mes (cobra el siguiente mes)
                            </p>
                          }
                        </div>
                      </div>
                    </div>
                  </Form.Field>
                  {/* {this.props.cliente.estadoCliente==='ACTIVO' && */}
                  {(this.props.cliente.estadoCliente==='ACTIVO'&&(this.props.list[0].estadoCerrarOS==='DESCONECTADO, SUSPENDIDO o RETIRADO'||this.props.list[0].estadoCerrarOS==='DESCONECTADO')) &&
                    <Form.Field>
                      <p style={this.props.styles.label}>
                        <input style={{margin: '0.2em 0em 0em 0em'}} type='checkbox' name="checkNoFactOsAb" checked={checkNoFactOsAb}  onChange={this.handleChange}/>
                        &nbsp;&nbsp;NO FACTURAR EN EL PROCESO DE FACTURACION MIENTRAS LA OS SE ENCUENTRE ABIERTA
                      </p>
                    </Form.Field>
                  }
                  {/* {(cargarCli!==0) &&
                    <Form.Field>
                      <p style={this.props.styles.label}>
                        <input style={{margin: '0.2em 0em 0em 0em'}} type='checkbox' name="checkNoFactOsAb" checked={checkNoFactOsAb}  onChange={this.handleChange}/>
                        &nbsp;&nbsp;NO TENER EN CUENTA LOS CARGOS AL CLIENTE (${cargarCli})
                      </p>
                    </Form.Field>
                  } */}

                  <Divider inverted />





{/* OTROS CARGOS */}
                  {(concepto1||concepto2||concepto3) &&
                    <div className='ui blue inverted raised segment' style={this.props.styles.backGr_2}>
                      {(this.props.list7[0].estadoOS==="ABIERTA") &&
                        <div>
                          <a className='ui large label' style={this.props.styles.styTableSup}>Cargos O de S</a>
                          <hr></hr>
                          <Form.Field>
                            <div className="ui three column stackable grid">
                              <div className="row container">
                                {concepto1 &&
                                  <div className="column" style={{width: '33%'}}>
                                    <label style={this.props.styles.label}>$ {concepto1} (antes de impuestos)</label>
                                    <input type='number' step="1" min="0" style={this.props.styles.input} autoComplete="off" name="valorCpto1" id="valorCpto1" value={valorCpto1===0?argsDocum.valorCpto1:valorCpto1} onChange={permCpto1?this.handleChange:()=>{}} placeholder='Valor'/>
                                  </div>
                                }
                                {concepto2 &&
                                  <div className="column" style={{width: '33%'}}>
                                    <label style={this.props.styles.label}>$ {concepto2} (antes de impuestos)</label>
                                    <input type='number' step="1" min="0" style={this.props.styles.input} autoComplete="off" name="valorCpto2" id="valorCpto3" value={valorCpto2===0?argsDocum.valorCpto2:valorCpto2} onChange={permCpto2?this.handleChange:()=>{}} placeholder='Valor'/>
                                  </div>
                                }
                                {concepto3 &&
                                  <div className="column" style={{width: '34%'}}>
                                    <label style={this.props.styles.label}>$ {concepto3} (antes de impuestos)</label>
                                    <input type='number' step="1" min="0" style={this.props.styles.input} autoComplete="off" name="valorCpto3" id="valorCpto3" value={valorCpto3===0?argsDocum.valorCpto3:valorCpto3} onChange={permCpto3?this.handleChange:()=>{}} placeholder='Valor'/>
                                  </div>
                                }
                              </div>
                            </div>
                          </Form.Field>
                        </div>
                      }
                      </div>
                    }




{/* RECURSOS */}
                  {(!this.props.permiteDir&&!this.props.permiteTar&&!this.props.permiteOfer&&!this.props.permiteEqu) && 
                    <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
                      <a className='ui large label' style={this.props.styles.styTableSup}>Recursos asignados a la O de S</a>
                      <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                        <thead className=''>
                          <tr className=''>
                            <th className=''></th>
                            <th className=''>Doc</th>
                            <th className=''>Número</th>
                            <th className=''>Recurso</th>
                            <th className=''>Tipo de recurso</th>
                          </tr>
                        </thead>
                        <ListaSup list={listSup} handleChange={this.handleChange}/>
                      </table>
                    </div>
                  }

{/* SELECCIONA Modificar */}
                  {this.props.permiteUpdate &&
                     <div className='ui blue inverted raised segment' style={this.props.styles.backGr_2}>
                      <a className='ui large label' style={this.props.styles.styTableInf}>Recursos sin asignar a la O de S</a>
                      <a className='ui large label' style={this.props.styles.styTableInf}><i className='delete center icon' onClick={this.props.handleCerrarWin}/></a>
                      <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableInf}>
                        <thead className=''>
                          <tr className=''>
                            <th className=''></th>
                            <th className=''>Doc</th>
                            <th className=''>Número</th>
                            <th className=''>Recurso</th>
                            <th className=''>Tipo de recurso</th>
                          </tr>
                        </thead>
                        <ListaInf list={listInf} handleChange={this.handleChange}/>
                      </table>
                    </div>
                  }

{/* DIRECCION */}
                  {(!this.props.permiteUpdate&&!this.props.permiteTar&&!this.props.permiteOfer&&
                    !this.props.permiteEqu&&this.props.list[0].permDireccion!=='DEJAR IGUAL') && 
                    <div className='ui blue inverted raised segment' style={this.props.styles.backGr_2}>
                      {(this.props.list7[0].estadoOS==="ABIERTA") &&
                        <div>
                          <a className='ui large label' style={this.props.styles.styTableSup}>Dirección actual</a>
                          <hr></hr>
                          <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                            <ListaDirAct linea0={descrEstratoDA} linea1={linea1DA} linea2={linea2DA} linea3={linea3DA} linea4={linea4DA}/>
                          </table>

                          <Divider inverted />
                        </div>
                      }
                        <a className='ui large label' style={this.props.styles.styTableInf}>Dirección nueva</a>
                        {(this.props.permiteUpdate||this.props.permiteDir||this.props.permiteTar||this.props.permiteOfer||this.props.permiteEqu) &&
                          <a className='ui large label' style={this.props.styles.styTableInf} onClick={(ev)=>this.props.handleQuitarDir(ev, codigoDpto)}><i className='trash icon'></i>Quitar dirección OS</a>
                        }
                        <hr></hr>
                        <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableInf}>
                          <ListaDirAct linea0={descrEstratoDN} linea1={linea1DN} linea2={linea2DN} linea3={linea3DN} linea4={linea4DN}/>
                        </table>
                      </div>
                  }

{/* SELECCIONA Dirección */}
                  {this.props.permiteDir &&
                    <div>
                      <Divider inverted />
                      <div className='ui blue inverted raised segment'>
                        <a className='ui large label' style={this.props.styles.styTableInf}>Cambiar dirección</a>
                        <a className='ui large label' style={this.props.styles.styTableInf}><i className='delete center icon' onClick={this.props.handleCerrarWin}/></a>
                        <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableInf}>
                          <ListaDirAct linea0={descrEstratoDNN} linea1={linea1DNN} linea2={linea2DNN} linea3={linea3DNN} linea4={linea4DNN}/>
                        </table>
                        <div className="ui two column stackable grid">
                          <div className="row container">
                            <div className="column" style={this.props.styles.boxGrid}>
                              <Form.Field>
                                <label style={this.props.styles.label}>Vía principal</label>
                                <Lista seleccLista="descrTipoVia1" list={this.props.list2} styles={this.props.styles} handleLista4={this.props.handleLista4}/>
                                <input style={this.props.styles.input} autoComplete="off" name="numeroTipoVia1" id="numeroTipoVia1" onChange={this.props.handleChange} placeholder='Número' icon={!errors.length?null: _find(errors, {path:'numeroTipoVia1'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                              </Form.Field>
                              <Form.Field>
                                <label style={this.props.styles.label}>Vía secundaria</label>
                                <Lista seleccLista="descrTipoVia2" list={this.props.list2} styles={this.props.styles} handleLista4={this.props.handleLista4}/>
                                <input style={this.props.styles.input} autoComplete="off" name="numeroTipoVia2" id="numeroTipoVia2" onChange={this.props.handleChange} placeholder='Número' icon={!errors.length?null: _find(errors, {path:'numeroTipoVia2'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                                <input style={this.props.styles.input} autoComplete="off" name="numeroTipoVia2F" id="numeroTipoVia2F" onChange={this.props.handleChange} placeholder='Número' icon={!errors.length?null: _find(errors, {path:'numeroTipoVia2F'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                              </Form.Field>
                              <Form.Field>
                                <label style={this.props.styles.label}>Tipo de unidad 1</label>
                                <Lista seleccLista="descrTipoUnd1" list={this.props.list3} styles={this.props.styles} handleLista4={this.props.handleLista4}/>
                                <input style={this.props.styles.input} autoComplete="off" name="numeroTipoUnd1" id="numeroTipoUnd1" onChange={this.props.handleChange} placeholder='Número' icon={!errors.length?null: _find(errors, {path:'numeroTipoUnd1'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                              </Form.Field>
                              <Form.Field>
                                <label style={this.props.styles.label}>Tipo de unidad 2</label>
                                <Lista seleccLista="descrTipoUnd2" list={this.props.list3} styles={this.props.styles} handleLista4={this.props.handleLista4}/>
                                <input style={this.props.styles.input} autoComplete="off" name="numeroTipoUnd2" id="numeroTipoUnd2" onChange={this.props.handleChange} placeholder='Número' icon={!errors.length?null: _find(errors, {path:'numeroTipoUnd2'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                              </Form.Field>
                            </div>
                            <div className="column" style={this.props.styles.boxGrid}>
                              <Form.Field>
                                <label style={this.props.styles.label}>Unidad matriz</label>
                                <Lista seleccLista="descrTiUndMat" list={this.props.list4} styles={this.props.styles} handleLista4={this.props.handleLista4}/>
                                <Lista seleccLista="descrUndMat" list={this.props.list5} styles={this.props.styles} handleLista4={this.props.handleLista4}/>
                              </Form.Field>
                              <Form.Field>
                                <label style={this.props.styles.label}>Departamento</label>
                                <ListaDe list={list1} styles={this.props.styles} handleLista={this.props.handleLista}
                                  codigoCiudadUA={this.props.codigoCiudadUA} codigoDptoUA={this.props.codigoDptoUA}/>
                              </Form.Field>
                              <Form.Field>
                                <label style={this.props.styles.label}>Ciudad</label>
                                <ListaCi list={list1} styles={this.props.styles} handleLista1={this.props.handleLista1}
                                  argsSelDpto={argsSelDpto} codigoCiudadUA={this.props.codigoCiudadUA}/>
                              </Form.Field>
                              <Form.Field>
                                <label style={this.props.styles.label}>Barrio</label>
                                <ListaBa list={list1} styles={this.props.styles} handleLista3={this.props.handleLista3} argsSelDpto={argsSelDpto}/>
                              </Form.Field>
                              <Form.Field>
                                <label style={this.props.styles.label}>Zona</label>
                                <ListaZo styles={this.props.styles} argsSelDpto={argsSelDpto}/>
                              </Form.Field>

                              {this.props.empresa.empresaArchFE==="codisert" &&
                                <Form.Field>
                                  <label style={this.props.styles.label}>Estrato</label>
                                  <Lista seleccLista="descrEstrato" list={list3Estr} styles={this.props.styles} handleLista4={this.props.handleLista4}/>
                                </Form.Field>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }

{/* TARIFAS */}
                  {(!this.props.permiteUpdate&&!this.props.permiteDir&&!this.props.permiteOfer&&
                    !this.props.permiteEqu&&this.props.list[0].permTarServ!=='DEJAR IGUAL') && 
                    <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
                      {(this.props.list7[0].estadoOS==="ABIERTA") &&
                        <div>
                          <a className='ui large label' style={this.props.styles.styTableSup}>Tarifa actual</a>
                          <hr></hr>
                          <a style={this.props.styles.elemLis_2}>{tarifaAct}</a>
                          <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                            <thead className=''>
                              <tr className=''>
                                <th className=''>Estado</th>
                                <th className=''>Clase</th>
                                <th className=''>Servicio</th>
                                <th className=''>Descripción servicio</th>
                                <th className='center aligned'># serv</th>
                                <th className='center aligned'>Valor serv</th>
                              </tr>
                            </thead>
                            <ListaServTar styles={this.props.styles} list={listServTarAct} permAct=''/>
                          </table>

                          <Divider inverted />
                        </div>
                      }
                      <a className='ui large label' style={this.props.styles.styTableInf}>Tarifa nueva</a>
                      {(this.props.permiteUpdate||this.props.permiteDir||this.props.permiteTar||this.props.permiteOfer||this.props.permiteEqu) &&
                        <a className='ui large label' style={this.props.styles.styTableInf} onClick={(ev)=>this.props.handleQuitarTar(ev, codigoTarifaNva)}><i className='trash icon'></i>Quitar tarifa OS</a>
                      }
                      <hr></hr>
                      <a style={this.props.styles.elemLis_2}>{tarifaNva}</a>
                      <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                        <thead className=''>
                          <tr className=''>
                            <th className=''></th>
                            <th className=''>Clase</th>
                            <th className=''>Servicio</th>
                            <th className=''>Descripción servicio</th>
                            <th className='center aligned'># serv</th>
                            <th className='center aligned'>Valor serv</th>
                          </tr>
                        </thead>
                        <ListaServTar styles={this.props.styles} list={listServTarNva} permAct=''/>
                      </table>
                    </div>
                  }

{/* SELECCIONA Tarifa / Servicios */}
                  {this.props.permiteTar &&
                    <div>
                      <Divider inverted />
                      <div className='ui blue inverted raised segment'>
                        <a className='ui large label' style={this.props.styles.styTableInf}>Cambiar tarifa / servicios</a>
                        <a className='ui large label' style={this.props.styles.styTableInf} onClick={this.handleRefreshTar}><i className='redo icon'></i>Refrescar</a>
                        <a className='ui large label' style={this.props.styles.styTableInf}><i className='delete center icon' onClick={this.props.handleCerrarWin}/></a>
                        <Form.Field>
                          <ListaTar codigoTarifaAct={codigoTarifaAct} codigoTarifaNva={codigoTarifaNva} list={this.props.list6}
                              listTOS={this.props.list} styles={this.props.styles} handleTarNva={this.handleTarNva}
                              cicloFact={this.props.cliente.cicloFact}/>
                          <label style={this.props.styles.label}>Fecha de vencimiento</label>
                          <input type='date' name="fechaVence" id="fechaVence" value={this.props.fechaV} onChange={(ev)=>this.props.handleChange(ev)}/>
                        </Form.Field>
                        <hr></hr>

                        <a style={this.props.styles.elemLis_2}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a>
                        <div className='ui fitted slider checkbox'>
                          <input style={{paddingLeft: '0.7em', paddingRight: '0.7em'}} type='checkbox' name='estadoSeleccTodo' checked={checkTodo} onChange={(ev)=>this.handleChangeTar(ev)}/>
                          <label />
                        </div>
                        <a style={this.props.styles.elemLis_2}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{labelTN1}</a>

                        <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                          <thead className=''>
                            <tr className=''>
                              <th className=''></th>
                              <th className=''>Clase</th>
                              <th className=''>Servicio</th>
                              <th className=''>Descripción servicio</th>
                              <th className='center aligned'># serv</th>
                              <th className='center aligned'>Valor serv</th>
                            </tr>
                          </thead>
                          <ListaServTar styles={this.props.styles} list={listServTar} permAct='cambiar' handleChangeTar={this.handleChangeTar} imptosCF={imptosCF}/>
                        </table>          

                        {/* <Divider inverted /> */}
                        <hr></hr>
                        <a style={this.props.styles.elemLis_2}>{labelTN2}</a>
                        <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableInf}>
                          <thead className=''>
                            <tr className=''>
                              <th className=''></th>
                              <th className=''>Clase</th>
                              <th className=''>Servicio</th>
                              <th className=''>Descripción servicio</th>
                            </tr>
                          </thead>
                          <ListaServ list={listServ} handleChangeTar={this.handleChangeTar} imptosCF={imptosCF}/>
                        </table>
                      </div>
                    </div>
                  }

{/* OFERTAS */}
                  {/* {(!this.props.permiteUpdate&&!this.props.permiteDir&&!this.props.permiteTar&&
                    !this.props.permiteEqu&&this.props.list[0].permOfertas!=='NO') && 
                    <div className='ui blue inverted raised segment' style={this.props.styles.backGr_2}>
                      {(this.props.list7[0].estadoOS==="ABIERTA") &&
                        <div>
                          <a className='ui large label' style={this.props.styles.styTableSup}>Oferta actual</a>
                          <hr></hr>
                          <a style={this.props.styles.elemLis_2}>{ofertaAct}</a>
                          <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                            <thead className=''>
                              <tr className=''>
                                <th className=''></th>
                                <th className=''>Clase</th>
                                <th className=''>Servicio</th>
                                <th className=''>Descripción servicio</th>
                                <th className='center aligned'>% Dcto</th>
                                <th className='center aligned'>Días oferta</th>
                              </tr>
                            </thead>
                            <ListaServOf list={listServOfAct}/>
                          </table>

                          <Divider inverted />
                        </div>
                      }
                      <a className='ui large label' style={this.props.styles.styTableInf}>Oferta nueva</a>
                      {(this.props.permiteUpdate||this.props.permiteDir||this.props.permiteTar||this.props.permiteOfer||this.props.permiteEqu) &&
                        <a className='ui large label' style={this.props.styles.styTableInf} onClick={(ev)=>this.props.handleQuitarOf(ev, codigoOfertaNva)}><i className='trash icon'></i>Quitar oferta OS</a>
                      }
                      <hr></hr>
                      <a style={this.props.styles.elemLis_2}>{ofertaNva}</a>
                      <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                        <thead className=''>
                          <tr className=''>
                            <th className=''></th>
                            <th className=''>Clase</th>
                            <th className=''>Servicio</th>
                            <th className=''>Descripción servicio</th>
                            <th className='center aligned'>% Dcto</th>
                            <th className='center aligned'>Días oferta</th>
                          </tr>
                        </thead>
                        <ListaServOf list={listServOfNva}/>
                      </table>
                    </div>
                  } */}

{/* SELECCIONA Oferta */}
                  {this.props.permiteOfer &&
                    <div>
                      <Divider inverted />
                      <div className='ui blue inverted raised segment'>
                        <a className='ui large label' style={this.props.styles.styTableInf}>Cambiar oferta</a>
                        <a className='ui large label' style={this.props.styles.styTableInf} onClick={this.handleRefreshTar}><i className='redo icon'></i>Refrescar</a>
                        <a className='ui large label' style={this.props.styles.styTableInf}><i className='delete center icon' onClick={this.props.handleCerrarWin}/></a>
                        <Form.Field>
                          <ListaOf codigoOfertaAct={codigoOfertaAct} codigoOfertaNva={codigoOfertaNva} list={this.props.list9} styles={this.props.styles} handleOfNva={this.handleOfNva}/>
                        </Form.Field>
                        <hr></hr>
                        <a style={this.props.styles.elemLis_2}>{labelON1}</a>
                        <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                          <thead className=''>
                            <tr className=''>
                              <th className=''></th>
                              <th className=''>Clase</th>
                              <th className=''>Servicio</th>
                              <th className=''>Descripción servicio</th>
                              <th className='center aligned'>% Dcto</th>
                              <th className='center aligned'>Días oferta</th>
                            </tr>
                          </thead>
                          <ListaServOf list={listServOf}/>
                        </table>          
                      </div>
                    </div>
                  }

{/* EQUIPOS */}
                  {(!this.props.permiteUpdate&&!this.props.permiteDir&&!this.props.permiteTar&&
                    !this.props.permiteOfer&&this.props.list[0].permEquipos!=='DEJAR IGUAL') && 
                    <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
                      {(this.props.list7[0].estadoOS==="ABIERTA") &&
                        <div>
                          <a className='ui large label' style={this.props.styles.styTableSup}>Equipos asignados</a>
                          <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                            <thead className=''>
                              <tr className=''>
                                <th className=''></th>
                                <th className=''>Serial</th>
                                <th className=''>Mac</th>
                                <th className=''>Clase</th>
                                <th className=''>Marca</th>
                                <th className=''>Fabricante</th>
                              </tr>
                            </thead>
                            <ListaEquiCli list={listEquiCliAct} permAct=''/>
                          </table>

                          <Divider inverted />
                        </div>
                      }
                      <a className='ui large label' style={this.props.styles.styTableInf}>Nueva relación de equipos</a>
                      {(this.props.permiteUpdate||this.props.permiteDir||this.props.permiteTar||this.props.permiteOfer||this.props.permiteEqu) &&
                        <a className='ui large label' style={this.props.styles.styTableInf} onClick={(ev)=>this.props.handleQuitarEqu(ev)}><i className='trash icon'></i>Quitar cambios de equipos en OS</a>
                      }
                      <Form.Field>
                        <label style={this.props.styles.elemLis_2}>Si hay retiro de equipos, entregar a la bodega</label>
                        <ListaBodega list={this.props.list11} styles={this.props.styles} handleLista={this.props.handleLista5} />
                      </Form.Field>
                      <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                        <thead className=''>
                          <tr className=''>
                            <th className=''></th>
                            <th className=''>Serial</th>
                            <th className=''>Mac</th>
                            <th className=''>Clase</th>
                            <th className=''>Marca</th>
                            <th className=''>Fabricante</th>
                          </tr>
                        </thead>
                        <ListaEquiCli list={listEquiCliNva} permAct=''/>
                      </table>
                    </div>
                  }

{/* SELECCIONA Equipos */}
                  {this.props.permiteEqu &&
                    <div>
                      <Divider inverted />
                      <div className='ui blue inverted raised segment'>
                        <a className='ui large label' style={this.props.styles.styTableInf}>Agregar/Quitar equipos</a>
                        <a className='ui large label' style={this.props.styles.styTableInf} onClick={()=>this.handleRefreshEqu(listEquiCliAsig, listEquiAsig)}><i className='redo icon'></i>Refrescar</a>
                        <a className='ui large label' style={this.props.styles.styTableInf}><i className='delete center icon' onClick={this.props.handleCerrarWin}/></a>
                        <Form.Field>
                          <div className="ui two column stackable grid">
                            <div className="row container">
                              <div className="column" style={this.props.styles.boxGrid}>
                                <label style={this.props.styles.label}>Serial</label>
                                <input style={this.props.styles.input} autoComplete="off" name="numeroSerie" id="numeroSerie" value={stNumeroSerie} onChange={(ev)=>this.handleChangeEqu(ev)} placeholder='Serial' />
                              </div>
                              <div className="column" style={this.props.styles.boxGrid}>
                                <label style={this.props.styles.label}>Mac</label>
                                <input style={this.props.styles.input} autoComplete="off" name="mac" id="mac" value={stMac} onChange={(ev)=>this.handleChangeEqu(ev)} placeholder='Mac' />
                              </div>
                            </div>
                          </div>
                          <Button style={this.props.styles.confirmar} onClick={()=>this.handleAgrEquipo(this.props.list10, listEquiCliAsig)} fluid>
                              {txtBtnAgrEq}
                          </Button>
                        </Form.Field>
                        <hr></hr>
                        <a style={this.props.styles.elemLis_2}>{labelEN1}</a>
                          <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                            <thead className=''>
                              <tr className=''>
                                <th className=''></th>
                                <th className=''>Serial</th>
                                <th className=''>Mac</th>
                                <th className=''>Clase</th>
                                <th className=''>Marca</th>
                                <th className=''>Fabricante</th>
                              </tr>
                            </thead>
                            <ListaEquiCli list={listEquiCliAsig} permAct='cambiar' handleChangeEqu={this.handleChangeEqu} nameEstado='estadoSeleccPpal'/>
                          </table>          

                        {/* <Divider inverted /> */}
                        <hr></hr>
                        <a style={this.props.styles.elemLis_2}>{labelEN2}</a>
                        <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableInf}>
                          <thead className=''>
                            <tr className=''>
                              <th className=''></th>
                              <th className=''>Serial</th>
                                <th className=''>Mac</th>
                                <th className=''>Clase</th>
                                <th className=''>Marca</th>
                                <th className=''>Fabricante</th>
                            </tr>
                          </thead>
                          <ListaEquiCli list={listEquiAsig} permAct='cambiar' handleChangeEqu={this.handleChangeEqu} nameEstado='estadoSelecc'/>
                        </table>
                      </div>
                    </div>
                  }

{/* CARGOS AL CLIENTE */}
                  {(!this.props.permiteUpdate&&!this.props.permiteDir&&!this.props.permiteTar&&
                    !this.props.permiteOfer&&!this.props.permiteEqu&&cargarCli!==0) && 
                    <div className='ui blue inverted raised segment'>
                      <a style={this.props.styles.elemLis_3}>{cargosTar}</a>
                      <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                        <thead className=''>
                          <tr className=''>
                            <th className=''></th>
                            <th className=''>Clase</th>
                            <th className=''>Servicio</th>
                            <th className=''>Descripción servicio</th>
                            <th className='center aligned'># serv</th>
                            <th className='center aligned'>Valor serv</th>
                          </tr>
                        </thead>
                        <ListaServTar styles={this.props.styles} list={listServCargoFraVer} permAct=''/>
                      </table>
                    </div>
                  }

{/* CERRAR LA OS */}
                  {(this.props.permiteClose||this.props.list7[0].estadoOS==="CERRADA") && 
                    <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
                      <Form.Field>
                        <label style={this.props.styles.elemLis_2}>Observaciones de cierre</label>
                        <input style={this.props.styles.input} autoComplete="off" name="observacCE" id="observacCE" value={this.props.permiteClose?argsDocum.observacCE:this.props.list7[0].observacCE} onChange={this.handleChange} placeholder='Observaciones de cierre' icon={!errors.length?null: _find(errors, {path:'observacCE'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                      </Form.Field>

                      {cptosOP.length>1 &&
                        <Form.Field>
                          <div className="ui two column stackable grid">
                            <div className="row container">
                              <div className="column" style={{width: '70%'}}>
                                <label style={this.props.styles.elemLis_2}>Concepto del nuevo cargo a próxima factura</label>
                                <ListaCpto styles={this.props.styles} list={cptosOP} argsDocum={argsDocum} permiteClose={this.props.permiteClose} handleCpto={this.handleCpto}/>
                              </div>
                              <div className="column" style={{width: '30%'}}>
                                <label style={this.props.styles.elemLis_2}>Valor</label>
                                <input type='number' step="1" min="0" style={this.props.styles.input} autoComplete="off" name="stValor" id="stValor" value={argsDocum.stValor} placeholder='Valor' onChange={(ev)=>this.handleChange(ev)}/>
                              </div>
                            </div>
                          </div>
                        </Form.Field>
                      }

                      {this.props.permiteClose&&this.props.list7[0].genOSDirAnt==="SI" &&
                        <Form.Field>
                          <div className="ui two column stackable grid">
                            <div className="row container">
                              <div className="column" style={this.props.styles.boxGrid}>
                                <label style={this.props.styles.elemLis_2}>Generar OS a dirección anterior:</label>
                                <ListaTOS styles={this.props.styles} list={listTOSDA} idLista={this.props.list7[0]} argsDocum={argsDocum} permiteClose={this.props.permiteClose} handleChange={this.handleChange}/>
                              </div>
                              <div className="column" style={this.props.styles.boxGrid}>
                                <label style={this.props.styles.elemLis_2}>Observaciones OS a dirección anterior</label>
                                <input style={this.props.styles.input} autoComplete="off" name="observacABOS" id="observacABOS" value={this.props.permiteClose?argsDocum.observacABOS:""} onChange={this.handleChange} placeholder='Observaciones OS' icon={!errors.length?null: _find(errors, {path:'observacABOS'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                              </div>
                            </div>
                          </div>
                        </Form.Field>
                      }

                      <Form.Field>
                        <div className="ui two column stackable grid">
                          <div className="row container">
                            <div className="column" style={this.props.styles.boxGrid}>
                              <label style={this.props.styles.elemLis_2}>Marquilla</label>
                              <input style={this.props.styles.input} autoComplete="off" name="codigoMarquilla" id="codigoMarquilla" value={this.props.permiteClose?argsDocum.codigoMarquilla:this.props.list7[0].codigoMarquilla?this.props.list7[0].codigoMarquilla:""} onChange={this.handleChange} placeholder='Marquilla' icon={!errors.length?null: _find(errors, {path:'codigoMarquilla'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                            </div>
                            <div className="column" style={this.props.styles.boxGrid}>
                              <label style={this.props.styles.elemLis_2}>Nodo</label>
                              <ListaNodo styles={this.props.styles} list={listNodo} idLista={this.props.list7[0]} argsDocum={argsDocum} permiteClose={this.props.permiteClose} handleChange={this.handleChange}/>
                            </div>
                          </div>
                        </div>
                      </Form.Field>

                      <Form.Field>
                        <label style={this.props.styles.elemLis_2}>Vendedor</label>
                        <ListaV styles={this.props.styles} list={this.props.list12} idLista={this.props.list7[0]} argsDocum={argsDocum} permiteClose={this.props.permiteClose} handleChange={this.handleChange}/>
                      </Form.Field>
                      {/* <Form.Field>
                        <label style={this.props.styles.elemLis_2}>Clasificación OS</label>
                        <ListaClOS styles={this.props.styles} list={listClOS} idLista={this.props.list7[0]} argsDocum={argsDocum} permiteClose={this.props.permiteClose} handleChange={this.handleChange}/>
                      </Form.Field> */}

                      <Form.Field>
                        <div className="ui two column stackable grid">
                          <div className="row container">
                            <div className="column" style={this.props.styles.boxGrid}>
                              <label style={this.props.styles.elemLis_2}>Clasificación OS</label>
                              <ListaClOS styles={this.props.styles} list={listClOS} idLista={this.props.list7[0]} argsDocum={argsDocum} permiteClose={this.props.permiteClose} handleChange={this.handleChange}/>
                            </div>
                            {(stlistServTarNva.codigoTarifa&&listPaq.length>1) &&
                            // {((stlistServTarNva.codigoTarifa||!argsDocum.codigoPaquete)&&listPaq.length>1) &&
                              <div className="column" style={this.props.styles.boxGrid}>
                                <label style={this.props.styles.elemLis_2}>Paquete</label>
                                <ListaPaq styles={this.props.styles} list={listPaq} idLista={this.props.list7[0]} argsDocum={argsDocum} permiteClose={this.props.permiteClose} handleChange={this.handleChange}/>
                              </div>
                            }
                          </div>
                        </div>
                      </Form.Field>

                      {this.props.listaEstCerr.length>1 &&
                        <Form.Field>
                          <label style={this.props.styles.elemLis_2}>Nuevo estado del cliente</label>
                          <ListaEC styles={this.props.styles} list={this.props.listaEstCerr} argsDocum={argsDocum} permiteClose={this.props.permiteClose} handleChange={this.handleChange}/>
                        </Form.Field>
                      }
                    </div>
                  }

{/* CANCELAR LA OS */}
                  {(this.props.permiteCancel||this.props.list7[0].estadoOS==="CANCELADA") && 
                    <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
                  <Form.Field>
                    <label style={this.props.styles.elemLis_2}>Observaciones para cancelar</label>
                    <input style={this.props.styles.input} autoComplete="off" name="observacCA" id="observacCA" value={this.props.permiteCancel?argsDocum.observacCA:this.props.list7[0].observacCA} onChange={this.handleChange} placeholder='Observaciones para cancelar' icon={!errors.length?null: _find(errors, {path:'observacCA'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                  </div>
                }

                  {(this.props.permiteUpdate||this.props.permiteCancel||this.props.permiteClose||this.props.permiteDir||this.props.permiteTar||this.props.permiteOfer||this.props.permiteEqu) &&
                    <Divider inverted />
                  }
                  <SeguroPermite mensaje={mensaje} permiteUpdate={this.props.permiteUpdate} permiteCancel={this.props.permiteCancel}
                        permiteClose={this.props.permiteClose} permiteDir={this.props.permiteDir}
                        permiteTar={this.props.permiteTar} permiteOfer={this.props.permiteOfer}
                        permiteEqu={this.props.permiteEqu} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                  {
                    errors.length?<Message negative header="Los siguientes errores:"
                    list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                  }

                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    )
  }
}

export default compose(
  graphql(queries.query.allClientes, {name:'allClientes2', options: (props) => {return {variables: {numDocum: 50}}}}),

  graphql(queries.query.allClasifOST, {name:'allClasifOST'}),
  graphql(queries.query.allNodo, {name:'allNodo'}),
  graphql(queries.query.allPaquete, {name:'allPaquete'}),
)(VerOS2)
